import mixins from "../mixins";
import { i18n } from "../translate"

const generateUID = mixins.generateUID.methods.generateUID;

export default {
  isEditMode: true,
  pageProperties: {
    testing: true,
    "pages": [
      { // ::PAGE Home Page
        "pageName": "homepage",
        "pageId": 1,
        "sections": [
          { // For Desktop
            "sectionId": "orbg8s",
            "class": "desktop-only",
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center",
              "position": "relative"
            },
            "fields": [
              { // Refresh Token
                "fieldType": "refresh-token",
                "fieldId": "ij3433"
              },
              { // DataLayer
                fieldId: "dte-003",
                fieldType: "dataLayer-event",
                properties: {
                  eventName: "PageView",
                  fbEvent: "PageView"
                }
              },
              { // Key Visual
                "fieldType": "key-visual",
                "fieldId": "296eg1",
                "properties": {
                  "grid": {
                    "columns": "12"
                  },
                  "styles": {
                    "padding": "0 0 0 0",
                    "border-radius": "16px",
                    "overflow": "hidden",
                    "margin": "56px 0 0 0"
                  },
                  "noContainer": true
                }
              },
              { // Steps Card
                "fieldId": "fu0923r",
                "fieldType": "empty-bucket",
                "properties": {
                  "grid": {
                    "columns": "10",
                    "marginTop": "114px",
                    "marginBottom": "60px",
                    "justifyContent": "center",
                    "alignItems": "center"
                  },
                  "styles": {
                    "justify-content": "center;",
                    "align-items": "center;"
                  },
                  "fields": [
                    {
                      "fieldType": "step-card-oralb",
                      "fieldId": "05m65j",
                      "properties": {
                        "titleColor": "var(--brand-color-4)",
                        "borderColor": "var(--brand-color-5)",
                        "imageSource": "/assets/images/steps/product.svg",
                        "stepNo": "1",
                        "stepTitle": "Step",
                        "stepDescription": "Select your product",
                        "grid": {
                          "columns": 6
                        }
                      }
                    },
                    { // STep 2
                      "fieldType": "step-card-oralb",
                      "fieldId": "05m65j",
                      "properties": {
                        "titleColor": "var(--brand-color-4)",
                        "borderColor": "var(--brand-color-5)",
                        "imageSource": "/assets/images/steps/receipt.svg",
                        "stepNo": "2",
                        "stepTitle": "Step",
                        "stepDescription": "Upload your receipt",
                        "grid": {
                          "columns": 6
                        }
                      }
                    },
                    { // Step 3
                      "fieldType": "step-card-oralb",
                      "fieldId": "05m65j",
                      "properties": {
                        "titleColor": "var(--brand-color-4)",
                        "borderColor": "var(--brand-color-5)",
                        "imageSource": "/assets/images/steps/register.svg",
                        "stepNo": "3",
                        "stepTitle": "Step",
                        "stepDescription": "Register",
                        "grid": {
                          "columns": 6
                        }
                      }
                    },
                    { //  Step 4
                      "fieldType": "step-card-oralb",
                      "fieldId": "05m65j",
                      "properties": {
                        "titleColor": "var(--brand-color-4)",
                        "borderColor": "var(--brand-color-5)",
                        "imageSource": "/assets/images/steps/reward.svg",
                        "stepNo": "4",
                        "stepTitle": "Step",
                        "stepDescription": "Get your money back",
                        "grid": {
                          "columns": 6
                        }
                      }
                    }
                  ]
                }
              },
              { // Button
                "fieldType": "empty-bucket",
                "properties": {
                  "grid": {
                    "columns": 12,
                    "marginTop": "40px",
                    "marginBottom": "100px",
                    "justifyContent": "center"
                  },
                  "styles": {
                    "justify-content": "center ;"
                  },
                  "fields": [
                    {
                      "fieldType": "button-component",
                      "fieldId": "x1p9hx",
                      "properties": {
                        "grid": {
                          "columns": "3"
                        },
                        "text": "Start Refund",
                        "addClass": "btn-next",
                        "disabled": false,
                        "action": [
                          {
                            "fn": "goToPage",
                            "params": "product-scan"
                          }
                        ]
                      }
                    }
                  ]
                }
              }
            ]
          },
          { // For Mobile
            "sectionId": "orbg8s",
            "class": "mobile-only",
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center",
              "position": "relative"
            },
            "fields": [
              // { // Refresh Token
              //   "fieldType": "refresh-token",
              //   "fieldId": "ij3433"
              // },
              { // DataLayer
                fieldId: "dte-003",
                fieldType: "dataLayer-event",
                properties: {
                  eventName: "PageView",
                  fbEvent: "PageView"
                }
              },
              { // Key Visual
                "fieldType": "key-visual",
                "fieldId": "296eg1",
                "properties": {
                  "grid": {
                    "columns": "12"
                  },
                  "styles": {
                    "padding": "0 0 0 0",
                    "border-radius": "16px",
                    "overflow": "hidden",
                    "margin": "24px",
                    "width": "auto"
                  },
                  "noContainer": true
                }
              },
              { // Steps Card
                "fieldId": "fu0923r",
                "fieldType": "empty-bucket",
                "properties": {
                  "grid": {
                    "columns": "12",
                    "marginTop": "24px"
                  },
                  "styles": {
                    "justify-content": "center;",
                    "align-items": "center;",
                    "width": "auto;"
                  },
                  "fields": [
                    {
                      "fieldType": "step-card-oralb",
                      "fieldId": "05m65j",
                      "properties": {
                        "titleColor": "var(--brand-color-4)",
                        "borderColor": "var(--brand-color-5)",
                        "imageSource": "/assets/images/steps/product.svg",
                        "stepNo": "1",
                        "stepTitle": "Step",
                        "stepDescription": "Select your product",
                        "grid": {
                          "columns": 6
                        }
                      }
                    },
                    {
                      "fieldType": "step-card-oralb",
                      "fieldId": "05m65j",
                      "properties": {
                        "titleColor": "var(--brand-color-4)",
                        "borderColor": "var(--brand-color-5)",
                        "imageSource": "/assets/images/steps/receipt.svg",
                        "stepNo": "2",
                        "stepTitle": "Step",
                        "stepDescription": "Upload your receipt",
                        "grid": {
                          "columns": 6
                        }
                      }
                    },
                    {
                      "fieldType": "step-card-oralb",
                      "fieldId": "05m65j",
                      "properties": {
                        "titleColor": "var(--brand-color-4)",
                        "borderColor": "var(--brand-color-5)",
                        "imageSource": "/assets/images/steps/register.svg",
                        "stepNo": "3",
                        "stepTitle": "Step",
                        "stepDescription": "Register",
                        "grid": {
                          "columns": 6
                        }
                      }
                    },
                    {
                      "fieldType": "step-card-oralb",
                      "fieldId": "05m65j",
                      "properties": {
                        "titleColor": "var(--brand-color-4)",
                        "borderColor": "var(--brand-color-5)",
                        "imageSource": "/assets/images/steps/reward.svg",
                        "stepNo": "4",
                        "stepTitle": "Step",
                        "stepDescription": "Get your money back",
                        "grid": {
                          "columns": 6
                        }
                      }
                    }
                  ]
                }
              },
              { // Button
                "fieldType": "empty-bucket",
                "properties": {
                  "grid": {
                    "columns": 12,
                    "marginTop": "40px",
                    "marginBottom": "80px",
                    justifyContent: "center"
                  },
                  "styles": {
                    "justify-content": "center;",
                    "width": "auto;"
                  },
                  "fields": [
                    {
                      "fieldType": "button-component",
                      "fieldId": "x1p9hx",
                      "properties": {
                        "grid": {
                          "columns": "3"
                        },
                        "text": "Start Refund",
                        "addClass": "btn-next",
                        "disabled": false,
                        "action": [
                          {
                            "fn": "goToPage",
                            "params": "product-scan"
                          }
                        ]
                      }
                    }
                  ]
                }
              }

            ]
          }
        ]
      },
      { // ::PAGE Product Scanner
        "pageName": "product-scan",
        "pageId": 11,
        "sections": [
          { // Step and Header
            "sectionId": "98j3bew9jm",
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center",
              "marginBottom": "50px"
            },
            "fields": [
              { // Progress bar
                "fieldType": "progress-bar",
                "fieldId": "x62vxc",
                "properties": {
                  "currentInterval": 1,
                  "currentStep": 1,
                  "stepCount": 3
                }
              },
              { // Header
                "fieldType": "paragraph",
                "fieldId": "0bbo32",
                "properties": {
                  "text": "Scan the product",
                  "classes": ["heading"],
                  "grid": {
                    "alignItems": "center",
                    "justifyContent": "center",
                    "columns": 12,
                    "marginBottom": "20px"
                  }
                }
              },
              { // Sub Header
                "fieldType": "paragraph",
                "fieldId": "94xqe4",
                "properties": {
                  "text": `Type in or scan the barcode`,
                  "classes": ["subHeading"],
                  "grid": {
                    "alignItems": "center",
                    "justifyContent": "center",
                    "columns": 12,
                    "marginBottom": "50px"
                  }
                }
              },
              { // Sub Text
                "fieldType": "paragraph",
                "fieldId": "94xqe4",
                "properties": {
                  "text": `Please enter the barcode number of your Oral-B product, take a photo of your promotional product or upload it using drag & drop. Please make sure that the barcode information of your promotional product is clearly visible.`,
                  "grid": {
                    "alignItems": "center",
                    "justifyContent": "center",
                    "columns": "12"
                  },
                  "classes": ["subText"]
                }
              },
              { // Image
                "fieldType": "square-image",
                "fieldId": "gb0wjv",
                "properties": {
                  "imageSource": "/assets/images/product_back_side.png",
                  "alternateText": "productBackSideAltText",
                  "grid": {
                    "alignItems": "center",
                    "justifyContent": "center",
                    "columns": 12,
                    "marginTop": "15px"
                  }
                }
              }
            ]
          },
          { // Barcode Scanner
            "sectionId": "bn54gef",
            "grid": {
              "alignItems": "center",
              "justifyContent": "center",
            },
            "fields": [
              { // Barcode Scanner
                "fieldType": "empty-bucket",
                "properties": {
                  "grid": {
                    "columns": 12
                  },
                  "styles": {
                    "justify-content": "center ;",
                    "margin": "0px;"
                  },
                  "fields": [
                    { // Barcode Scanner
                      "fieldType": "barcode-scanner-oralb",
                      "fieldId": "56hythe",
                      "properties": {
                        "grid": {
                          "columns": 12,
                          padding: 0
                        },
                        "successAction": {
                          "fn": "goToPage",
                          "params": "receipt-upload"
                        },
                        "texts": {
                          receiptUpload: 'Upload',
                          receiptUploadDescription: 'Upload barcode image',
                          receiptUploadSubDescription: 'Upload barcode image via drag & drop or from your device folder',
                          barcodeScan: 'Scan',
                          barcodeScanDescription: 'Scan the barcode image',
                          barcodeScanSubDescription: 'the easiest',
                          barcodeAdd: 'Add',
                          barcodeAddDescription: 'Add barcode',
                          wrongFormat: 'This file format is not supported. Only .jpeg, .png, .pdf and .tiff files are accepted.',
                          fileSizeLimit: 'The file is too big. Only files up to 16 MB are supported.',
                          timedOut: 'Unfortunately no valid barcode can be recognized. Please try to enter the barcode in the field above.',
                          cameraNotFound: 'Please turn on your camera',
                          invalidBarCode: `The barcode number is invalid`,
                          validBarcode: 'The barcode number is valid'
                        },
                        "apiUrl": "https://national-cashback.justsnap.eu/api/",
                        "cameraTimeOut": 20000,
                        "maxProductCount": 5
                      }
                    }
                  ]
                }
              }
            ]
          }
        ]
      },
      { // ::PAGE Receipt Upload
        "pageName": "receipt-upload",
        "pageId": 2,
        "sections": [
          { // Steps and Header
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center",
              "marginBottom": "50px"
            },
            "sectionId": "fu30zq",
            "fields": [
              { // Progress bar
                "fieldType": "progress-bar",
                "fieldId": "x62vxc",
                "properties": {
                  "currentInterval": 2,
                  "currentStep": 2,
                  "stepCount": 3
                }
              },
              { // Heading
                "fieldType": "paragraph",
                "fieldId": "uwxo2o",
                "properties": {
                  "text": "Upload receipt",
                  "classes": ["heading"],
                  "grid": {
                    "alignItems": "center",
                    "justifyContent": "center",
                    "columns": "12",
                    "marginBottom": "20px"
                  }
                }
              },
              { // Sub Heading
                "fieldType": "paragraph",
                "fieldId": "vb309g",
                "properties": {
                  "text": "Upload a picture of your proof of purchase now.",
                  "classes": ["subHeading"],
                  "grid": {
                    "alignItems": "center",
                    "justifyContent": "center",
                    "columns": "12",
                    "marginBottom": "50px"
                  }
                }
              },
              { // Sub Text
                "fieldType": "paragraph",
                "fieldId": "94xqe4",
                "properties": {
                  "text": `Upload your receipt photo using drag and drop. Only JPEG, PDF and PNG are supported. Maximum file size: 16MB.`,
                  "grid": {
                    "alignItems": "center",
                    "justifyContent": "center",
                    "columns": "12"
                  },
                  "classes": ["subText"]
                }
              }
            ]
          },
          { // Receipt Info and Upload
            "sectionId": "dyx8uv",
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "fields": [
              {
                "fieldType": "empty-bucket",
                "fieldId": "h453eadaf",
                "properties": {
                  "grid": {
                    "columns": 12
                  },
                  "styles": {
                    "justify-content": "center"
                  },
                  "fields": [
                    { // Recipt upload
                      "fieldType": "receipt-processor",
                      "fieldId": "klvakj",
                      "properties": {
                        texts: {
                          choose: 'Choose a file',
                          receiptUpload1: 'Upload your receipt photo',
                          receiptUpload2: 'Drag & Drop or click here',
                          wrongFormat: 'This file format is not supported. Only .jpeg, .png, .pdf and .tiff files are accepted.',
                          fileSizeLimit: 'The file is too big. Only files up to 16 MB are supported.'
                        },
                        "colorSchema": "var(--brand-color-2)",
                        "grid": {
                          "columns": "6",
                          "alignItems": "center",
                          "justifyContent": "center"
                        },
                        "addClass": "col-sm-9 col-md-6",
                        "successAction": {
                          "fn": "goToPage",
                          "params": "product-upload-be"
                        },
                        "phrases": [
                          "Your receipt will now be uploaded and processed.",
                          "The receipt is processed automatically.This can take a minute.Please be patient.",
                          "If you get an error message, please take a better version of the receipt and upload it again."
                        ],
                        "cornerDetectionPhrases": [
                          "Please drag your receipt into the gray rectangle.",
                          "You can erase private information with the razor tool."
                        ],
                        "eraseColor": "#ffffff",
                        "eraseSize": 12,
                        "cropColor": "#3A96F3",
                        "cropBackground": "rgba(0,0,0,0.6)",
                        "cropTitle": "Crop",
                        "eraseTitle": "Rub out",
                        "dragTitle": "Drag",
                        "zoomInTitle": "Zoom in",
                        "zoomOutTitle": "Zoom out",
                        "selectImageTitle": "Select an Image",
                        "selectAnotherTitle": "Select Another",
                        "controlsBackground": "#4193d3",
                        "backgroundColorBtn": "var(--brand-color-2)"
                      }
                    },
                    { // Receipt Info
                      "fieldType": "empty-bucket",
                      "fieldId": "vdf932fd",
                      "properties": {
                        "grid": {
                          "columns": "6"
                        },
                        "className": "col-sm-9 col-md-6",
                        "fields": [
                          {
                            "fieldType": "receipt-information",
                            "fieldId": "5mq1p6",
                            "properties": {
                              "grid": {
                                "alignItems": "center",
                                "justifyContent": "center",
                                "columns": "12"
                              },
                              shouldDisplayFull: true,
                              "descriptionText": `Please photograph your proof of purchase!`,
                              "descriptionSubText": `Make sure that the following information is clearly visible:`,
                              "hideExamples": true,
                              "steps": [
                                { // Retailer
                                  "text": "Retailer",
                                  "label": "A"
                                },
                                {
                                  "text": "Promotional product and purchase price",
                                  "label": "B"
                                },
                                {
                                  "text": "Total of the proof of purchase",
                                  "label": "C"
                                },
                                {
                                  "text": "Date and time of purchase",
                                  "label": "D"
                                },
                                {
                                  "text": "Proof of purchase ID",
                                  "label": "E"
                                }
                              ]
                            }
                          }
                        ]
                      }
                    },
                    { // Receipt Examples
                      "fieldType": "empty-bucket",
                      "properties": {
                        "grid": {
                          "columns": 12,
                          "justifyContent": "center",
                          "margin": "0px auto"
                        },
                        "classes": "receiptUploader",
                        "fields": [
                          {
                            "fieldType": "receipt-examples",
                            "fieldId": "5mq1p6",
                            "properties": {
                              "grid": {
                                "alignItems": "center",
                                "justifyContent": "center",
                                "columns": "8"
                              }
                            }
                          }
                        ]
                      }
                    }
                  ]
                }
              }
            ]
          },
          { // Buttons
            "sectionId": "r0924fw",
            "grid": {
              "columns": 10,
              "alignItems": "center"
            },
            "className": "button-section",
            "fields": [
              {
                "fieldId": "dfk2fw3",
                "fieldType": "empty-bucket",
                "properties": {
                  "grid": {
                    "columns": 8,
                    "justifyContent": "space-between",
                    "marginBottom": "50px"
                  },
                  "classes": "flex-nowrap",
                  "fields": [
                    { // Back
                      "fieldType": "button-component",
                      "fieldId": "gfdg32",
                      "properties": {
                        "grid": {
                          "columns": 4,
                          "alignItems": "center",
                          "justifyContent": "center"
                        },
                        "text": "Back",
                        "addClass": "btn-back",
                        "disabled": false,
                        "action": {
                          "fn": "goToPage",
                          "params": "product-scan"
                        }
                      }
                    },
                    { // Next
                      "fieldType": "button-component",
                      "fieldId": "cwer23452q",
                      "properties": {
                        "grid": {
                          "columns": 4,
                          "alignItems": "center",
                          "justifyContent": "center"
                        },
                        "text": "Next",
                        "addClass": "btn-next",
                        "shouldCheckCrop": true,
                        "requires": ["klvakj"],
                        "action": {
                          "fn": "sendReceipt",
                          "params": ""
                        }
                      }
                    }
                  ]
                }
              }
            ]
          }
        ]
      },
      { // ::PAGE Product Upload back side
        "pageName": "product-upload-be",
        "pageId": 252,
        "sections": [
          { // Steps and Heading
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center",
              "marginBottom": "50px"
            },
            "sectionId": "vgw364bh",
            "fields": [
              { // Progress bar
                "fieldType": "progress-bar",
                "fieldId": "x62vxc",
                "properties": {
                  "currentInterval": 2,
                  "currentStep": 2,
                  "stepCount": 3
                }
              },
              { // Heading
                "fieldType": "paragraph",
                "fieldId": "uwxo2o",
                "properties": {
                  "text": "Upload product photo",
                  "classes": ["heading"],
                  "grid": {
                    "alignItems": "center",
                    "justifyContent": "center",
                    "columns": "12",
                    "marginBottom": "20px"
                  }
                }
              },
              { // Sub Heading
                "fieldType": "paragraph",
                "fieldId": "vb309g",
                "properties": {
                  "text": "Please upload a photo of the product page on which the EAN barcode is clearly visible.",
                  "classes": ["subHeading"],
                  "grid": {
                    "alignItems": "center",
                    "justifyContent": "center",
                    "columns": "12",
                    "marginBottom": "50px"
                  }
                }
              },
              { // Sub Text
                "fieldType": "paragraph",
                "fieldId": "94xqe4",
                "properties": {
                  "text": `Upload your receipt photo using drag and drop. Only JPEG and PNG are supported. Maximum file size: 16MB.`,
                  "grid": {
                    "alignItems": "center",
                    "justifyContent": "center",
                    "columns": "12"
                  },
                  "classes": ["subText"]
                }
              }
            ]
          },
          { // Product Uploader
            "sectionId": "dyx8uv",
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center",
              "marginBottom": "50px"
            },
            "fields": [
              {
                "fieldType": "empty-bucket",
                "fieldId": "h453eadaf",
                "properties": {
                  "grid": {
                    "columns": "12"
                  },
                  "styles": {
                    "justifyContent": "center !important",
                    "maxWidth": "871px !important",
                    padding: 0
                  },
                  "className": "col-sm-9 col-xl-6",
                  "fields": [
                    {
                      "fieldType": "product-upload",
                      "fieldId": "3sxumo",
                      "properties": {
                        texts: {
                          choose: 'Choose a file',
                          receiptUpload1: 'Upload product photo',
                          receiptUpload2: 'Drag & Drop or click here',
                          wrongFormat: 'This file format is not supported. Only .jpeg, .png, .pdf and .tiff files are accepted.',
                          fileSizeLimit: 'The file is too big. Only files up to 16 MB are supported.'
                        },
                        "colorSchema": "var(--brand-color-2)",
                        "grid": {
                          "columns": "12",
                          "alignItems": "center",
                          "justifyContent": "center"
                        },
                        "apiUrl": "https://template-v2.justsnap.eu/api/uploadProductPhoto",
                        "successAction": {
                          "fn": "goToPage",
                          "params": "register"
                        }
                      }
                    }
                  ]
                }
              }
            ]
          },
          { // Buttons
            "sectionId": "r0924fw",
            "grid": {
              "columns": 10,
              "alignItems": "center"
            },
            "className": "button-section",
            "fields": [
              {
                "fieldId": "dfk2fw3",
                "fieldType": "empty-bucket",
                "properties": {
                  "grid": {
                    "columns": 8,
                    "justifyContent": "space-between",
                    "marginBottom": "50px"
                  },
                  "classes": "flex-nowrap",
                  "fields": [
                    { // Back
                      "fieldType": "button-component",
                      "fieldId": "gfdg32",
                      "properties": {
                        "grid": {
                          "columns": 4,
                          "alignItems": "center",
                          "justifyContent": "center"
                        },
                        "text": "Back",
                        "addClass": "btn-back",
                        "disabled": false,
                        "action": {
                          "fn": "goToPage",
                          "params": "receipt-upload"
                        }
                      }
                    },
                    { // Next
                      "fieldType": "button-component",
                      "fieldId": "cwer23452q",
                      "properties": {
                        "grid": {
                          "columns": 4,
                          "alignItems": "center",
                          "justifyContent": "center"
                        },
                        "text": "Next",
                        "addClass": "btn-next",
                        "shouldCheckCrop": true,
                        "requires": ["3sxumo"],
                        "action": {
                          "fn": "sendProductPhotos",
                          "params": "3sxumo"
                        }
                      }
                    }
                  ]
                }
              }
            ]
          }
        ]
      },
      { // ::PAGE Registration
        "pageName": "register",
        "pageId": 43253214,
        // isPublic: true,
        "sections": [
          { // Steps and Heading
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center",
              "marginBottom": "50px"
            },
            "fields": [
              { // Progress bar
                "fieldType": "progress-bar",
                "fieldId": "x62vxc",
                "properties": {
                  "currentInterval": 3,
                  "currentStep": 3,
                  "stepCount": 3
                }
              },
              { // Heading
                "fieldType": "paragraph",
                "fieldId": "uwxo2o",
                "properties": {
                  "text": "Registration form",
                  "classes": ["heading"],
                  "grid": {
                    "alignItems": "center",
                    "justifyContent": "center",
                    "columns": "12",
                    "marginBottom": "20px"
                  }
                }
              },
              { // Sub Heading
                "fieldType": "paragraph",
                "fieldId": "vb309g",
                "properties": {
                  "text": "We need the following information from you to process the payment. These are only used to process the Oral-B Money-back campaign.",
                  "classes": ["subHeading"],
                  "grid": {
                    "alignItems": "center",
                    "justifyContent": "center",
                    "columns": "12",
                    "marginBottom": "50px"
                  }
                }
              }
            ]
          },
          { // Form
            "sectionId": "ci88zt",
            "grid": {
              "alignItems": "center",
              "justifyContent": "center",
              "columns": 12,
              "marginBottom": "50px"
            },
            "fields": [
              {
                "fieldType": "form-component",
                "fieldId": "inzf4w",
                "properties": {
                  "styles": {
                    "margin": "0",
                    "alignItems": "center",
                    "flexDirection": "column"
                  },
                  "grid": {
                    "columns": "12",
                    "alignItems": "center",
                    "justifyContent": "center"
                  },
                  "requires": [
                    "1"
                  ],
                  "successAction": {
                    "fn": "goToPage",
                    "params": "iban"
                  },
                  "apiUrl": "https://template-v2.justsnap.eu/api/register",
                  "fields": [
                    { // Fields
                      "fieldType": "empty-bucket",
                      "fieldId": "4h3gweb",
                      "properties": {
                        "grid": {
                          "columns": 10,
                          "justifyContent": "center",
                          "alignItems": "center"
                        },
                        "classes": "form-top-wrapper",
                        "fields": [
                          {
                            "fieldType": "empty-bucket",
                            "fieldId": "f934if",
                            "properties": {
                              "grid": {
                                "columns": 12,
                                "justifyContent": "left",
                                "alignItems": "flex-start",
                                "columnGap": "10px"
                              },
                              "classes": "form-wrapper",
                              "fields": [
                                { // Personal Information
                                  "fieldType": "paragraph",
                                  "fieldId": "vb309g",
                                  "properties": {
                                    "text": "Personal information",
                                    "classes": ["subHeading"],
                                    "grid": {
                                      "alignItems": "center",
                                      "justifyContent": "center",
                                      "columns": "12",
                                      "marginBottom": "20px"
                                    }
                                  }
                                },
                                { // Gender
                                  "fieldType": "empty-bucket",
                                  "fieldId": "emp12312",
                                  "properties": {
                                    "grid": {
                                      "columns": 12,
                                      "alignItems": "center",
                                      "marginBottom": "20px"
                                    },
                                    "fields": [
                                      { // Gender
                                        "fieldType": "radio-input",
                                        "fieldId": "Geschlecht",
                                        "properties": {
                                          "text": "",
                                          "name": "gender",
                                          "id": "gender",
                                          "label": "Title",
                                          "color": "#000",
                                          labelOnTop: true,
                                          "grid": {
                                            "columns": 6
                                          },
                                          "validation": "",
                                          "direction": "row",
                                          "options": [
                                            {
                                              "value": "female",
                                              "text": "Mrs",
                                              "disabled": false,
                                              "name": "firstRadio"
                                            },
                                            {
                                              "value": "male",
                                              "text": "Mr",
                                              "disabled": false,
                                              "name": "secondRadio"
                                            }
                                          ]
                                        }
                                      }
                                    ]
                                  }
                                },
                                { // Left Side
                                  "fieldType": "empty-bucket",
                                  "fieldId": "mep123",
                                  "properties": {
                                    "grid": {
                                      "columns": 6,
                                      "justifyContent": "center",
                                      "alignItems": "flex-start"
                                    },
                                    "fields": [
                                      { // Firstname
                                        "fieldId": "b4baqs",
                                        "fieldType": "text-input",
                                        "properties": {
                                          "name": "firstName",
                                          "id": "firstName",
                                          "label": "First name",
                                          "placeholder": "Enter your first name",
                                          labelOnTop: true,
                                          "validation": "required|namesWithHyphensAndSpaces",
                                          "grid": {
                                            "alignItems": "center",
                                            "justifyContent": "center",
                                            "columns": 12
                                          },
                                          "styles": {
                                            "margin-bottom": "20px"
                                          }
                                        }
                                      }
                                      // { // Birthdate
                                      //   "fieldId": "godate",
                                      //   "fieldType": "date-input",
                                      //   "properties": {
                                      //     "name": "birthdate",
                                      //     "id": "birthdate",
                                      //     "label": "Date of birth",
                                      //     "placeholder": "dd/mm/yyyy",
                                      //     "validation": "",
                                      //     "grid": {
                                      //       "columns": "12"
                                      //     },
                                      //     labelOnTop: true,
                                      //     "params": {
                                      //       "disabledDates": {
                                      //         "from": "18years",
                                      //         "to": "01.01.1900"
                                      //       }
                                      //     },
                                      //     "styles": {
                                      //       "margin-bottom": "20px"
                                      //     }
                                      //   }
                                      // }
                                    ]
                                  }
                                },
                                { // Right side
                                  "fieldType": "empty-bucket",
                                  "fieldId": "mep123",
                                  "properties": {
                                    "grid": {
                                      "columns": 6,
                                      "justifyContent": "center",
                                      "alignItems": "flex-start"
                                    },
                                    "fields": [
                                      { // Last name
                                        "fieldId": "gofije",
                                        "fieldType": "text-input",
                                        "properties": {
                                          "name": "lastName",
                                          "id": "lastName",
                                          "label": "Last name",
                                          "placeholder": "Enter your last name",
                                          labelOnTop: true,
                                          "validation": "required|namesWithHyphensAndSpaces",
                                          "grid": {
                                            "columns": 12
                                          },
                                          "styles": {
                                            "margin-bottom": "20px"
                                          }
                                        }
                                      },
                                    ]
                                  }
                                },
                                { // Email - Left Side Below
                                  "fieldType": "empty-bucket",
                                  "fieldId": "mep123-email",
                                  "properties": {
                                    "grid": {
                                      "columns": 6,
                                      "justifyContent": "center",
                                      "alignItems": "flex-start"
                                    },
                                    "styles": {
                                      "order": "3",
                                      "margin-right": "auto"
                                    },
                                    "fields": [
                                      { // Email
                                        "fieldId": "h7kzf9",
                                        "fieldType": "text-input",
                                        "properties": {
                                          "name": "email",
                                          "id": "email",
                                          "label": "E-mail address",
                                          "placeholder": "Enter your email",
                                          labelOnTop: true,
                                          "validation": "required|email",
                                          "grid": {
                                            "columns": 12
                                          },
                                          "styles": {
                                            "margin-bottom": "20px"
                                          }
                                        }
                                      }
                                    ]
                                  }
                                },
                                // { // Address
                                //   "fieldType": "paragraph",
                                //   "fieldId": "vb309g",
                                //   "properties": {
                                //     "text": "Address",
                                //     "classes": ["subHeading"],
                                //     "grid": {
                                //       "alignItems": "center",
                                //       "justifyContent": "center",
                                //       "columns": "12",
                                //       "marginTop": "40px",
                                //       "marginBottom": "20px"
                                //     }
                                //   }
                                // },
                                // { // Left Side
                                //   "fieldType": "empty-bucket",
                                //   "fieldId": "mep123",
                                //   "properties": {
                                //     "grid": {
                                //       "columns": 6,
                                //       "justifyContent": "center",
                                //       "alignItems": "flex-start"
                                //     },
                                //     "fields": [
                                //       { // Street
                                //         "fieldId": "b5q97u",
                                //         "fieldType": "text-input",
                                //         "properties": {
                                //           "name": "strasse",
                                //           "id": "strasse",
                                //           "label": "Streetname",
                                //           "placeholder": "Enter your street name",
                                //           labelOnTop: true,
                                //           "validation": "required",
                                //           "grid": {
                                //             "columns": 12
                                //           },
                                //           "styles": {
                                //             "margin-bottom": "20px"
                                //           }
                                //         }
                                //       },
                                //       { // PLZ
                                //         "fieldId": "ql6mu5",
                                //         "fieldType": "text-input",
                                //         "properties": {
                                //           "name": "plz",
                                //           "id": "plz",
                                //           "label": "Postal Code",
                                //           "placeholder": "Enter your Postal code",
                                //           labelOnTop: true,
                                //           "validation": "required|postal",
                                //           "grid": {
                                //             "columns": 12
                                //           },
                                //           "styles": {
                                //             "margin-bottom": "20px"
                                //           }
                                //         }
                                //       },
                                //       { // Country
                                //         "fieldId": "x3d8oz",
                                //         "fieldType": "select-input",
                                //         "properties": {
                                //           "name": "land",
                                //           "id": "land",
                                //           "label": "Country",
                                //           "placeholder": "Choose a country",
                                //           labelOnTop: true,
                                //           "validation": "required",
                                //           "options": [
                                //             {
                                //               "text": "Denmark",
                                //               "value": "Denmark"
                                //             },
                                //             {
                                //               "text": "Finland",
                                //               "value": "Finland"
                                //             },
                                //             {
                                //               "text": "Norway",
                                //               "value": "Norway"
                                //             },
                                //             {
                                //               "text": "Sweden",
                                //               "value": "Sweden"
                                //             },
                                //           ],
                                //           "selectedValue": "",
                                //           "grid": {
                                //             "columns": 12
                                //           },
                                //           "styles": {
                                //             "margin-bottom": "20px"
                                //           }
                                //         }
                                //       }
                                //     ]
                                //   }
                                // },
                                // { // Right side
                                //   "fieldType": "empty-bucket",
                                //   "fieldId": "mep123",
                                //   "properties": {
                                //     "grid": {
                                //       "columns": 6,
                                //       "justifyContent": "center",
                                //       "alignItems": "flex-start"
                                //     },
                                //     "fields": [
                                //       { // House number
                                //         "fieldId": "ql5mu4",
                                //         "fieldType": "text-input",
                                //         "properties": {
                                //           "name": "hausnr",
                                //           "id": "hausnr",
                                //           "label": "Number",
                                //           "placeholder": "Enter your house number",
                                //           labelOnTop: true,
                                //           "validation": "",
                                //           "grid": {
                                //             "columns": 12
                                //           },
                                //           "col6mobile": true,
                                //           "styles": {
                                //             "margin-bottom": "20px"
                                //           }
                                //         }
                                //       },
                                //       { // City
                                //         "fieldId": "jdtxik",
                                //         "fieldType": "text-input",
                                //         "properties": {
                                //           "name": "ort",
                                //           "id": "ort",
                                //           "label": "City",
                                //           "placeholder": "Enter a city you live",
                                //           labelOnTop: true,
                                //           "validation": "required|alpha",
                                //           "grid": {
                                //             "columns": 12
                                //           },
                                //           "styles": {
                                //             "margin-bottom": "20px"
                                //           }
                                //         }
                                //       }
                                //     ]
                                //   }
                                // }
                              ]
                            }
                          }
                        ]
                      }
                    },
                    { // Checkboxes
                      "fieldId": "8k2f023f",
                      "fieldType": "empty-bucket",
                      "properties": {
                        "grid": {
                          "columns": 10
                        },
                        "className": "col-md-6 col-xl-4",
                        "fields": [
                          {
                            "fieldType": "checkbox",
                            "fieldId": "wgc3j7",
                            "properties": {
                              "name": "terms",
                              "id": "terms",
                              "validation": {
                                "mandatory": {
                                  "allowFalse": false
                                }
                              },
                              "grid": {
                                "columns": "12",
                                "paddingbottom": "10px"
                              },
                              "styles": {
                                "margin-top": "30px"
                              },
                              "label": `I confirm that I am over 18 years old. I confirm the terms and conditions, privacy policy & Justsnap privacy policy.`
                            }
                          },
                          {
                            "fieldType": "checkbox",
                            "fieldId": "wgc3j8",
                            "properties": {
                              "name": "campaignTermsAccepted",
                              "id": "campaignTermsAccepted",
                              "label": `I have read the Conditions of participation for this promotion and accept them.`,
                              "validation": {
                                "mandatory": {
                                  "allowFalse": false
                                }
                              },
                              "grid": {
                                "columns": "12",
                                "paddingTop": "10px"
                              }
                            }
                          },
                          { // Opt in
                            "fieldType": "checkbox",
                            "fieldId": "psyn1c",
                            "properties": {
                              "name": "receiveEmails",
                              "id": "receiveEmails",
                              "grid": {
                                "columns": "12",
                                "paddingTop": "10px"
                              },
                              "validation": {
                                "mandatory": {
                                  "allowFalse": true
                                }
                              },
                              "label": `Always up-to-date with our newsletters. I want to receive emails, offers and coupons from Oral-B - the community for power women and super moms - and other trusted P&G brands.`
                            }
                          },
                          { // Registration Notice
                            "fieldType": "paragraph",
                            "fieldId": "registration-notice",
                            "properties": {
                              "text": "Registration Notice",
                              "grid": {
                                "alignItems": "center",
                                "justifyContent": "center",
                                "columns": "12",
                                "marginTop": "20px"
                              }
                            }
                          }
                        ]
                      }
                    }
                  ]
                }
              }
            ]
          },
          { // Buttons
            "sectionId": "hmgwhl",
            "grid": {
              "columns": 10,
              "alignItems": "center"
            },
            "className": "button-section",
            "fields": [
              {
                "fieldId": "dfk2fw3",
                "fieldType": "empty-bucket",
                "properties": {
                  "grid": {
                    "columns": 8,
                    "justifyContent": "space-between",
                    "marginBottom": "50px"
                  },
                  "classes": "flex-nowrap",
                  "fields": [
                    { // Back
                      "fieldType": "button-component",
                      "fieldId": "16tzm2",
                      "properties": {
                        "grid": {
                          "columns": 4,
                          "alignItems": "center",
                          "justifyContent": "center"
                        },
                        "text": "Back",
                        "addClass": "btn-back",
                        "disabled": false,
                        "action": {
                          "fn": "goToPage",
                          "params": "product-upload-be"
                        }
                      }
                    },
                    { // Next
                      "fieldType": "button-component",
                      "fieldId": "16tzm2",
                      "properties": {
                        "grid": {
                          "columns": 4,
                          "alignItems": "center",
                          "justifyContent": "center"
                        },
                        "addClass": "btn-next",
                        "text": "Next",
                        "disabled": false,
                        "action": {
                          "fn": "sendForm",
                          "params": "inzf4w"
                        }
                      }
                    }
                  ]
                }
              }
            ]
          }
        ]
      },
      { // ::PAGE Banking Page
        "pageName": "iban",
        "pageId": 3,
        "requires": [
          1
        ],
        "sections": [
          { // Step Counter and Heading
            "grid": {
              "alignItems": "center",
              "justifyContent": "center",
              "flex-direction": "column",
              "columns": 12
            },
            "fields": [
              { // Progress bar
                "fieldType": "progress-bar",
                "fieldId": "x62vxc",
                "properties": {
                  "currentInterval": 3,
                  "currentStep": 3,
                  "stepCount": 3
                }
              },
              { // Heading
                "fieldType": "paragraph",
                "fieldId": "uwxo2o",
                "properties": {
                  "text": "Specify bank details",
                  "classes": ["heading"],
                  "grid": {
                    "alignItems": "center",
                    "justifyContent": "center",
                    "columns": "12",
                    "marginBottom": "20px"
                  }
                }
              },
              { // Sub Heading
                "fieldType": "paragraph",
                "fieldId": "vb309g",
                "properties": {
                  "text": "Please enter the first and last name of the account holder exactly as they were given at the bank.",
                  "classes": ["subHeading"],
                  "grid": {
                    "alignItems": "center",
                    "justifyContent": "center",
                    "columns": "12",
                    "marginBottom": "50px"
                  }
                }
              },
              { // Sub Text
                "fieldType": "paragraph",
                "fieldId": "94xqe4",
                "properties": {
                  "text": `Avoid changing the umlauts: Müller or Mueller. Avoid adding or leaving out hyphens: Marie Luise or Marie-Luise. Only enter the middle name if the account is also managed with it.`,
                  "grid": {
                    "alignItems": "center",
                    "justifyContent": "center",
                    "columns": "12"
                  },
                  "classes": ["subText"]
                }
              }
            ]
          },
          { // Form Component
            "sectionId": "mfh0h1",
            "grid": {
              "alignItems": "center",
              "justifyContent": "center",
              "columns": "12"
            },
            "fields": [
              {
                "fieldType": "form-component",
                "fieldId": "bank1Nf0",
                "properties": {
                  "checkIbanCountry": true,
                  "successAction": {
                    "fn": "goToPage",
                    "params": "thank-you"
                  },
                  "apiUrl": "https://template-v2.justsnap.eu/api/submitIBAN",
                  "keepInState": ["referenceNumber"],
                  "grid": {
                    "alignItems": "center",
                    "justifyContent": "center",
                    "columns": "12"
                  },
                  "styles": {
                    "margin": "0",
                    "alignItems": "center",
                    "flexDirection": "column"
                  },
                  "fields": [
                    {
                      "fieldType": "empty-bucket",
                      "fieldId": "f934if",
                      "properties": {
                        "grid": {
                          "columns": "6",
                          "justifyContent": "center",
                          "alignItems": "center"
                        },
                        "classes": "form-top-wrapper",
                        "fields": [
                          {
                            "fieldType": "empty-bucket",
                            "fieldId": "emep123",
                            "properties": {
                              "grid": {
                                "columns": 12,
                                "justifyContent": "center",
                                "alignItems": "center"
                              },
                              "classes": "form-wrapper",
                              "fields": [
                                { // IBAN
                                  "fieldId": "h9arlr",
                                  "fieldType": "text-input",
                                  "properties": {
                                    "name": "iban",
                                    "id": "iban",
                                    "validation": "required|iban",
                                    "label": "IBAN",
                                    "placeholder": "Enter your IBAN",
                                    "isUpperCase": true,
                                    "text": "",
                                    "toolTip": {
                                      "title": "What is IBAN and where do I find it?",
                                      "text": `IBAN stands for International Bank Account Number. It's an internationally-agreed code made up of up to 34 letters and numbers that helps banks to process transfers around the world. You can usually find your IBAN number on the top right- hand side of your bank statement or in your online banking.If you can't locate your IBAN, you should be able to generate it online via your bank's internet banking service or by using an IBAN calculator tool.`
                                    },
                                    labelOnTop: true,
                                    "grid": {
                                      "columns": "12"
                                    },
                                    "styles": {
                                      "font-family": 'Montserrat',
                                      "margin-bottom": "20px"
                                    }
                                  }
                                },
                                { // BIC
                                  "fieldId": "v1nf34",
                                  "fieldType": "text-input",
                                  "properties": {
                                    "name": "bic",
                                    "id": "bic",
                                    "label": "BIC",
                                    "validation": "required|bic",
                                    "placeholder": "Enter your BIC",
                                    "isUpperCase": true,
                                    labelOnTop: true,
                                    "toolTip": {
                                      "title": "What is BIC and where do I find it?",
                                      "text": "BIC stands for Bank Identifier Code. To send or receive money, any financial institution must know where to send the money and BIC is exactly what shows it. You can usually find your bank's BIC in your bank account statements.If you're using online banking, log into your digital bank account to easily view your bank statement or contact your bank so that they provide you your BIC."
                                    },
                                    "grid": {
                                      "columns": "12"
                                    },
                                    styles: {
                                      "margin-bottom": "20px"
                                    }
                                  }
                                },
                                { // Firstname
                                  "fieldId": "tp6zfb",
                                  "fieldType": "text-input",
                                  "properties": {
                                    "name": "firstname",
                                    "id": "firstname",
                                    "label": "Account holder first name",
                                    "placeholder": "Enter your first name",
                                    "validation": "required|namesWithHyphensAndSpaces",
                                    labelOnTop: true,
                                    "grid": {
                                      "columns": "12"
                                    },
                                    styles: {
                                      "margin-bottom": "20px"
                                    }
                                  }
                                },
                                { // Last name
                                  "fieldId": "p55fao",
                                  "fieldType": "text-input",
                                  "properties": {
                                    "name": "lastname",
                                    "id": "lastname",
                                    "label": "Account holder last name",
                                    "placeholder": "Enter your last name",
                                    "validation": "required|namesWithHyphensAndSpaces",
                                    labelOnTop: true,
                                    "grid": {
                                      "columns": "12"
                                    }
                                  }
                                }
                              ]
                            }
                          }
                        ]
                      }
                    }
                  ]
                }
              },
              { // Disclaimer
                "fieldType": "paragraph",
                "fieldId": "0bbo32",
                "properties": {
                  "text": "If the data does not exactly match the account details, in most cases the bank will charge back and make the process of an uncomplicated and quick refund more difficult.",
                  "grid": {
                    "alignItems": "center",
                    "justifyContent": "center",
                    "columns": "6",
                    "marginTop": "15px",
                    "marginBottom": "50px"
                  },
                  "styles": {
                    "font-size": "14px"
                  }
                }
              }
            ]
          },
          { // Buttons
            "sectionId": "hmgwhl",
            "grid": {
              "columns": 10,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "className": "button-section",
            "fields": [
              {
                "fieldId": "dfk2fw3",
                "fieldType": "empty-bucket",
                "properties": {
                  "grid": {
                    "columns": 8,
                    "justifyContent": "center",
                    "marginBottom": "50px"
                  },
                  "classes": "flex-nowrap",
                  "fields": [
                    { // Next
                      "fieldType": "button-component",
                      "fieldId": "16tzm2",
                      "properties": {
                        "grid": {
                          "columns": 4,
                          "alignItems": "center",
                          "justifyContent": "center"
                        },
                        "addClass": "btn-next",
                        "text": "Next",
                        "disabled": false,
                        "action": {
                          "fn": "sendForm",
                          "params": "bank1Nf0"
                        }
                      }
                    }
                  ]
                }
              }
            ]
          }
        ]
      },
      { // ::PAGE Thank you Page
        "pageName": "thank-you",
        "isPublic": true,
        "pageId": 99,
        "sections": [
          { // Steps and Heading
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center",
              "marginBottom": "50px"
            },
            "fields": [
              { // Heading
                "fieldType": "paragraph",
                "fieldId": "uwxo2o",
                "properties": {
                  "text": "Thank you for your participation",
                  "classes": ["heading"],
                  "grid": {
                    "alignItems": "center",
                    "justifyContent": "center",
                    "columns": "12",
                    "marginBottom": "20px",
                    "marginTop": "10vh"
                  }
                }
              },
              { // Sub Heading
                "fieldType": "paragraph",
                "fieldId": "vb309g",
                "properties": {
                  "text": "Your receipt and your data have been successfully sent to us and are now being checked.",
                  "classes": ["subHeading"],
                  "grid": {
                    "alignItems": "center",
                    "justifyContent": "center",
                    "columns": "12",
                    "marginBottom": "50px"
                  }
                }
              }
            ]
          },
          { // Clipboard and image
            "grid": {
              "alignItems": "center",
              "justifyContent": "center",
              "columns": 12,
              "marginBottom": "50px"
            },
            "fields": [
              { // Ref and Image
                "fieldType": "empty-bucket",
                "fieldId": "emp1231258",
                "properties": {
                  "grid": {
                    "columns": 12,
                    "justifyContent": "center",
                    "marginBottom": "50px"
                  },
                  "fields": [
                    { // Reference Number
                      "fieldType": "empty-bucket",
                      "fieldId": "emp123123",
                      "properties": {
                        "grid": {
                          "columns": 6,
                          "justifyContent": "flex-start",
                          "alignItems": "center"
                        },
                        "classes": "col-12",
                        "fields": [
                          { // Clipboard
                            "fieldType": "clipboard",
                            "fieldId": "ref123",
                            "properties": {
                              "grid": {
                                "columns": 10,
                                "padding-left": "0",
                                "padding-right": "0"
                              },
                              "disabledInput": true,
                              "title": "Reference number:",
                              "variables": {
                                "referenceNumber": "referenceNumber"
                              }
                            }
                          }
                        ]
                      }
                    },
                    { // Image
                      "fieldType": "empty-bucket",
                      "fieldId": "emp123123",
                      "properties": {
                        "grid": {
                          "columns": 6,
                          "justify-content": "center",
                          media: {
                            query: "max-width: 991px",
                            grid: {
                              "display": "none"
                            }
                          }
                        },
                        "fields": [
                          {
                            "fieldType": "square-image",
                            "fieldId": "5vk986f7",
                            "properties": {
                              "imageSource": "/assets/images/thankyou.png",
                              'localImage': true,
                              "grid": {
                                "alignItems": "center",
                                "justifyContent": "center",
                                "columns": 10
                              },
                              "styles": {
                                "maxHeight": "400px",
                                "maxWidth": "480px"
                              }
                            }
                          }
                        ]
                      }
                    }
                  ]
                }
              },
              { // Paragraph
                "fieldType": "paragraph",
                "fieldId": "par12312",
                "properties": {
                  "grid": {
                    "columns": 12,
                    "justifyContent": "center"
                  },
                  "text": `As soon as we have checked your data, you will either receive a confirmation e-mail or an e-mail with queries if your data was incomplete or your proof of purchase could not be recorded. This can take up to 36 hours. We ask for your patience. After successfully checking the proof of purchase and all other data as well as succesfully receiving the product you would like to return, we will transfer the reimbursement amount to the account you specified within 6 weeks. If anything is unclear, we will contact you again by email.`,
                  "classes": ["subText"]
                }
              },
              { // Paragraph, return in 10 days
                "fieldType": "paragraph",
                "fieldId": "0bbo32",
                "properties": {
                  "text": "Please do not forget, if you want to return your product you have to send the product back to our Service Center address within 10 days after your confirmation of your participation.",
                  "grid": {
                    "alignItems": "center",
                    "justifyContent": "center",
                    "columns": "12",
                    "marginTop": "15px"
                  },
                  "classes": ["subHeading"],
                  "styles": {
                    "font-size": "16px;",
                    "font-weight": "bold;",
                    "margin": "40px 0 10px 0;"
                  }
                }
              }
            ]
          },
          { // Button
            "sectionId": "1265vb4k",
            "grid": {
              "columns": 10,
              "alignItems": "center",
              "justifyContent": "flex-start"
            },
            "fields": [
              { // Button
                "fieldType": "button-component",
                "fieldId": "7bltcc",
                "properties": {
                  "grid": {
                    "columns": 3,
                    "alignItems": "center",
                    "justifyContent": "center",
                    "paddingTop": "10px",
                    "paddingBottom": "10px",
                    "marginBottom": "50px"
                  },
                  "text": "Back to the homepage",
                  'addClass': 'btn-back',
                  "disabled": false,
                  "action": {
                    "anchor": true,
                    "link": "website-link"
                  }
                }
              }
            ]
          }
        ]
      },
      { // ::PAGE Survey
        "pageName": "survey",
        "pageId": 5237,
        isPublic: true,
        "sections": [
          { // Steps and Heading
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center",
              "marginBottom": "50px"
            },
            "fields": [
              { // Heading
                "fieldType": "paragraph",
                "fieldId": "uwxo2o",
                "properties": {
                  "text": "Survey",
                  "classes": ["heading"],
                  "grid": {
                    "alignItems": "center",
                    "justifyContent": "center",
                    "columns": "12",
                    "marginBottom": "20px",
                    "marginTop": "10vh"
                  }
                }
              }
            ]
          },
          { // Form
            "sectionId": "ci88zt",
            "grid": {
              "alignItems": "center",
              "justifyContent": "center",
              "columns": 12,
              "marginBottom": "50px"
            },
            "fields": [
              { // Query String
                "fieldType": "query-string-to-state",
                "fieldId": "uwxo2o1",
                properties: {
                  variables: [
                    {
                      query: "customerToken",
                      state: "customerToken"
                    },
                    {
                      query: "receiptToken",
                      state: "receiptToken"
                    }
                  ]
                }
              },
              { // Survey component
                "fieldType": "survey",
                "fieldId": "sur100",
                "properties": {
                  "grid": {
                    "columns": 10,
                    "justifyContent": "flex-start"
                  },
                  "mandatory": false,
                  "apiUrl": "https://template-v2.justsnap.eu/api/survey",
                  "successAction": {
                    "fn": "goToPage",
                    "params": "return-form"
                  },
                  "questions": [
                    {
                      name: "checkbox-1",
                      type: "checkbox",
                      text: "What were the main reasons for you to buy this product?",
                      subText: "Please select as applicable",
                      options: ["Easy to use", "Design", "Price / good deal", "Performance", "Other"],
                      otherOption: true,
                      otherText: "Other"
                    },
                    {
                      name: "checkbox-2",
                      type: "checkbox",
                      text: "Why would you like to return the product?",
                      subText: "Please select as applicable",
                      options: ["It doesn't work as expected", "Wrong item size or wrong product", "Changed mind after Product Purchased", "Product didn't match the website or catalog Description", "Found better product price elsewhere", "Product did not meet my expectations"],
                      otherOption: false
                    }
                  ]
                }
              }
            ]
          },
          { // Buttons
            "sectionId": "hmgwhl",
            "grid": {
              "columns": 10,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "fields": [
              { // Next
                "fieldType": "button-component",
                "fieldId": "16tzm2",
                "properties": {
                  "grid": {
                    "columns": 4,
                    "alignItems": "center",
                    "justifyContent": "center",
                    "marginBottom": "50px"
                  },
                  "addClass": "btn-next",
                  "text": "Next",
                  "disabled": false,
                  "action": {
                    "fn": "sendSurvey",
                    "params": ""
                  }
                }
              }
            ]
          }
        ]
      },
      { // ::PAGE Return Form
        "pageName": "return-form",
        "pageId": 43253754,
        isPublic: true,
        "sections": [
          { // Steps and Heading
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center",
              "marginBottom": "50px"
            },
            "fields": [
              { // Heading
                "fieldType": "paragraph",
                "fieldId": "uwxo2o",
                "properties": {
                  "text": "Return form",
                  "classes": ["heading topPadding"],
                  "grid": {
                    "alignItems": "center",
                    "justifyContent": "center",
                    "columns": "12"
                  }
                }
              }
            ]
          },
          { // Form
            "sectionId": "ci88zt",
            "grid": {
              "alignItems": "center",
              "justifyContent": "center",
              "columns": 12,
              "margin": "auto"
            },
            "fields": [
              {
                "fieldType": "return-form-component",
                "fieldId": "gdj2h3",
                "properties": {
                  styles: {
                    "display": " block;",
                    "text-align": "center;",
                    "font-size": "30px;",
                    "margin-top": "30px;",
                    "margin-bottom": "0.83em;",
                    "margin-left": "0;",
                    "margin-right": "0;",
                    "font-weight": "bold;"
                  },
                  "grid": {
                    "alignItems": "center",
                    "justifyContent": "center",
                    "columns": "12",
                    "marginTop": "50px",
                    "marginBottom": "50px"
                  }
                }
              }
            ]
          },
          {
            "sectionId": "hmgwhl",
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center",
              "marginBottom": "50px"
            },
            "fields": [
              {
                "fieldType": "button-component",
                "fieldId": "16tzm2",
                "properties": {
                  "grid": {
                    "columns": "3",
                    "alignItems": "center",
                    "justifyContent": "center"
                  },
                  "text": "Print",
                  "addClass": "btn-next",
                  "requires": ["gdj2h3"],
                  "action": {
                    "fn": "printForm",
                    "params": ""
                  }
                }
              }
            ]
          }
        ]
      },
      { // ::PAGE Reclaim Page
        "pageName": "re-claim",
        "isPublic": true,
        "sections": [
          {
            "grid": {
              "alignItems": "center",
              "justifyContent": "center",
              "columns": 12
            },
            "fields": [
              {
                "fieldType": "reclaim-bucket",
                "fieldId": "r3cla1m3uket",
                "properties": {
                  "grid": {
                    "alignItems": "center",
                    "justifyContent": "center",
                    "columns": 12
                  },
                  "colorSchema": "#009639",
                  "apiUrl": "https://template-v2.justsnap.eu/api/reclaim",
                  "fields": [
                    { // Heading
                      "fieldType": "paragraph",
                      "fieldId": "uwxo2o",
                      "properties": {
                        "text": "Ready",
                        "classes": ["heading"],
                        "grid": {
                          "alignItems": "center",
                          "justifyContent": "center",
                          "columns": "12",
                          "marginBottom": "20px",
                          "marginTop": "50px"
                        }
                      }
                    },
                    { // Sub Heading
                      "fieldType": "paragraph",
                      "fieldId": "vb309g",
                      "properties": {
                        "text": "Thank you for the message.",
                        "classes": ["subHeading"],
                        "grid": {
                          "alignItems": "center",
                          "justifyContent": "center",
                          "columns": "12",
                          "marginBottom": "50px"
                        }
                      }
                    },
                    { // Sub Text
                      "fieldType": "paragraph",
                      "fieldId": "94xqe4",
                      "properties": {
                        "text": `We will check the reimbursement amount again and then inform you. The verification may take some time, so we ask for your patience.`,
                        "grid": {
                          "alignItems": "center",
                          "justifyContent": "center",
                          "columns": "12"
                        },
                        "classes": ["subText"]
                      }
                    },
                    { // Image
                      "fieldType": "square-image",
                      "fieldId": "gb0wjv",
                      "properties": {
                        "imageSource": "/assets/images/reclaim.png",
                        "alternateText": "reclaimImageAltText",
                        "grid": {
                          "alignItems": "center",
                          "justifyContent": "center",
                          "columns": 12,
                          "marginTop": "5px",
                          "marginBottom": "100px"
                        },
                        styles: {
                          "max-width": "1000px"
                        }
                      }
                    },
                    { // Button
                      "fieldType": "empty-bucket",
                      "fieldId": "emp562342",
                      "properties": {
                        "grid": {
                          "columns": 12,
                          "justifyContent": "flex-start",
                          "alignItems": "center"
                        },
                        "fields": [
                          { // Button
                            "fieldType": "button-component",
                            "fieldId": "7bltcc",
                            "properties": {
                              "grid": {
                                "columns": 3,
                                "alignItems": "center",
                                "justifyContent": "center",
                                "paddingTop": "10px",
                                "paddingBottom": "10px",
                                "marginBottom": "50px"
                              },
                              "text": "Back to the Oral-B website",
                              'addClass': 'btn-back',
                              "disabled": false,
                              "action": {
                                "anchor": true,
                                "link": "oralb_website"
                              }
                            }
                          }
                        ]
                      }
                    }
                  ],
                  "failFields": [
                    {
                      "fieldType": "paragraph",
                      "fieldId": "vnaped",
                      "properties": {
                        "text": "<center><p>Es ist ein Fehler aufgetreten</p></center>",
                        "grid": {
                          "alignItems": "center",
                          "justifyContent": "center",
                          "columns": "12"
                        }
                      }
                    },
                    {
                      "fieldType": "paragraph",
                      "fieldId": "oql2db",
                      "properties": {
                        "text": "<center>Derzeit liegt ein Problem bei unserer Website vor. Bitte versuchen Sie es in einigen Minuten erneut.</center>",
                        "grid": {
                          "alignItems": "center",
                          "justifyContent": "center",
                          "columns": "12",
                          "marginBottom": "30vh"
                        }
                      }
                    }
                  ],
                  "notFoundFields": [
                    {
                      "fieldType": "paragraph",
                      "fieldId": "vnaped",
                      "properties": {
                        "text": "<center><p>Ups, das hätte nicht passieren dürfen</p></center>",
                        "grid": {
                          "alignItems": "center",
                          "justifyContent": "center",
                          "columns": "12"
                        }
                      }
                    },
                    {
                      "fieldType": "paragraph",
                      "fieldId": "oql2db",
                      "properties": {
                        "text": "<center>Es liegt ein technischer Fehler vor. Bitte warte einen Augenblick und versuche es erneut.</center>",
                        "grid": {
                          "alignItems": "center",
                          "justifyContent": "center",
                          "columns": "12",
                          "marginBottom": "30vh"
                        }
                      }
                    }
                  ],
                  "expiredFields": [
                    {
                      "fieldType": "paragraph",
                      "fieldId": "vnaped",
                      "properties": {
                        "text": "<center><p>Uuupps… Leider ist sind die 48 Stunden bereits abgelaufen.</p></center>",
                        "grid": {
                          "alignItems": "center",
                          "justifyContent": "center",
                          "columns": "12"
                        }
                      }
                    },
                    {
                      "fieldType": "paragraph",
                      "fieldId": "oql2db",
                      "properties": {
                        "text": "<center>Bitte schreibe uns einfach eine E-Mail an kontakt@ariel-lenor-testwochen.de.<b>Bitte gebe in der E-Mail unbedingt deine persönliche Vorgangsnummer an.</b></center>",
                        "grid": {
                          "alignItems": "center",
                          "justifyContent": "center",
                          "columns": "12",
                          "marginBottom": "30vh"
                        }
                      }
                    }
                  ]
                }
              }
            ]
          }
        ]
      },
      { // Terms and Conditions
        "pageName": "terms",
        "isPublic": true,
        "sections": [
          {
            "grid": {
              "alignItems": "center",
              "justifyContent": "center",
              "columns": "12",
              "margin-bottom": "30px"
            },
            "fields": [
              {
                "fieldType": "conditions",
                "fieldId": "vabd69",
                "properties": {
                  "grid": {
                    "alignItems": "center",
                    "justifyContent": "center",
                    "columns": 12
                  }
                }
              }
            ]
          }
        ]
      },
      { // FAQ
        "pageName": "faq",
        "isPublic": true,
        "sections": [
          {
            "grid": {
              "alignItems": "center",
              "justifyContent": "center",
              "columns": "12",
              "margin-bottom": "30px"
            },
            "fields": [
              {
                "fieldType": "faq",
                "fieldId": "vabd70",
                "properties": {
                  "grid": {
                    "alignItems": "center",
                    "justifyContent": "center",
                    "columns": 12
                  }
                }
              }
            ]
          }
        ]
      },
      { // ::PAGE 404
        "pageName": "404",
        "pageId": 10424,
        isPublic: true,
        "sections": [
          { // Heading and subheading
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center",
              "marginBottom": "50px"
            },
            "fields": [
              { // Heading
                "fieldType": "paragraph",
                "fieldId": "uwxo2o",
                "properties": {
                  "text": "Oops!!",
                  "classes": ["heading"],
                  "grid": {
                    "alignItems": "center",
                    "justifyContent": "center",
                    "columns": "12",
                    "marginBottom": "20px",
                    "marginTop": '10vh'
                  }
                }
              },
              { // Sub Heading
                "fieldType": "paragraph",
                "fieldId": "vb309g",
                "properties": {
                  "text": "Something went wrong!",
                  "classes": ["subHeading"],
                  "grid": {
                    "alignItems": "center",
                    "justifyContent": "center",
                    "columns": "12",
                    "marginBottom": "50px"
                  }
                }
              }
            ]
          },
          { // Image
            "sectionId": "65vb4k",
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center",
              "marginBottom": "50px"
            },
            "fields": [
              {
                "fieldType": "square-image",
                "fieldId": "5vk986f7",
                "properties": {
                  "imageSource": "/assets/images/error.png",
                  'localImage': true,
                  "grid": {
                    "alignItems": "center",
                    "justifyContent": "center",
                    "columns": 12
                  },
                  "styles": {
                    "maxWidth": "715px"
                  }
                }
              }
            ]
          },
          { // Button
            "sectionId": "1265vb4k",
            "grid": {
              "columns": 10,
              "alignItems": "center",
              "justifyContent": "flex-start"
            },
            "fields": [
              { // Button
                "fieldType": "button-component",
                "fieldId": "7bltcc",
                "properties": {
                  "grid": {
                    "columns": 3,
                    "alignItems": "center",
                    "justifyContent": "center",
                    "paddingTop": "10px",
                    "paddingBottom": "10px",
                    "marginBottom": "50px"
                  },
                  "text": "Back to the homepage",
                  'addClass': 'btn-back',
                  "disabled": false,
                  "action": {
                    "anchor": true,
                    "link": "home-link"
                  }
                }
              }
            ]
          }
        ]
      },
      { // ::PAGE Expired page
        "pageName": "expired",
        "pageId": 10425,
        isPublic: true,
        "sections": [
          { // Heading and subheading
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center",
              "marginBottom": "50px"
            },
            "fields": [
              { // Heading
                "fieldType": "paragraph",
                "fieldId": "uwxo2o",
                "properties": {
                  "text": "Unfortunately the link is no longer valid!",
                  "classes": ["heading"],
                  "grid": {
                    "alignItems": "center",
                    "justifyContent": "center",
                    "columns": "12",
                    "marginBottom": "20px",
                    "marginTop": '10vh'
                  }
                }
              },
              { // Sub Heading
                "fieldType": "paragraph",
                "fieldId": "vb309g",
                "properties": {
                  "text": "Please participate again or contact our support team: contact@oral-b-moneyback.com",
                  "classes": ["subHeading"],
                  "grid": {
                    "alignItems": "center",
                    "justifyContent": "center",
                    "columns": "12",
                    "marginBottom": "30vh"
                  }
                }
              }
            ]
          },
          { // Button
            "sectionId": "1265vb4k",
            "grid": {
              "columns": 10,
              "alignItems": "center",
              "justifyContent": "flex-start"
            },
            "fields": [
              { // Button
                "fieldType": "button-component",
                "fieldId": "7bltcc",
                "properties": {
                  "grid": {
                    "columns": 3,
                    "alignItems": "center",
                    "justifyContent": "center",
                    "paddingTop": "10px",
                    "paddingBottom": "10px",
                    "marginBottom": "50px"
                  },
                  "text": "Back to the homepage",
                  'addClass': 'btn-back',
                  "disabled": false,
                  "action": {
                    "anchor": true,
                    "link": "home-link"
                  }
                }
              }
            ]
          }
        ]
      },
      { // ::PAGE Campaign Is Over
        "pageName": "over",
        "pageId": 1041,
        isPublic: true,
        "sections": [
          { // Heading and subheading
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center",
              "marginBottom": "50px"
            },
            "fields": [
              { // Heading
                "fieldType": "paragraph",
                "fieldId": "uwxo2o",
                "properties": {
                  "text": "The campaign period is over",
                  "classes": ["heading"],
                  "grid": {
                    "alignItems": "center",
                    "justifyContent": "center",
                    "columns": "12",
                    "marginBottom": "20px",
                    "marginTop": '10vh'
                  }
                }
              },
              { // Sub Heading
                "fieldType": "paragraph",
                "fieldId": "vb309g",
                "properties": {
                  "text": "Thank you for your interest in the campaign, unfortunately the campaign period is over.",
                  "classes": ["subHeading"],
                  "grid": {
                    "alignItems": "center",
                    "justifyContent": "center",
                    "columns": "12",
                    "marginBottom": "50px"
                  }
                }
              }
            ]
          },
          { // Image
            "sectionId": "65vb4k",
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center",
              "marginBottom": "50px"
            },
            "fields": [
              {
                "fieldType": "square-image",
                "fieldId": "5vk986f7",
                "properties": {
                  "imageSource": "/assets/images/over.png",
                  'localImage': true,
                  "grid": {
                    "alignItems": "center",
                    "justifyContent": "center",
                    "columns": 12
                  },
                  "styles": {
                    "maxWidth": "1100px"
                  }
                }
              }
            ]
          },
          { // Button
            "sectionId": "1265vb4k",
            "grid": {
              "columns": 10,
              "alignItems": "center",
              "justifyContent": "flex-start"
            },
            "fields": [
              { // Button
                "fieldType": "button-component",
                "fieldId": "7bltcc",
                "properties": {
                  "grid": {
                    "columns": 3,
                    "alignItems": "center",
                    "justifyContent": "center",
                    "paddingTop": "10px",
                    "paddingBottom": "10px",
                    "marginBottom": "50px"
                  },
                  "text": "Back to the Oral-B website",
                  'addClass': 'btn-back',
                  "disabled": false,
                  "action": {
                    "anchor": true,
                    "link": "oralb_website"
                  }
                }
              }
            ]
          }
        ]
      },
      { // ::PAGE Receipt Re Upload
        "pageName": "receipt-re-upload",
        "isPublic": true,
        "pageId": 102,
        "sections": [
          { //Query and  Heading
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "sectionId": "fu30zq",
            "fields": [
              { // Query String
                "fieldType": "query-string-to-state",
                "fieldId": "uwxo2o1",
                properties: {
                  variables: [
                    {
                      query: "referenceNumber",
                      state: "formData"
                    }
                  ]
                }
              },
              { // Heading
                "fieldType": "paragraph",
                "fieldId": "uwxo2o",
                "properties": {
                  "text": "Re-Upload your receipt",
                  "classes": ["heading"],
                  "grid": {
                    "alignItems": "center",
                    "justifyContent": "center",
                    "columns": "12",
                    "marginBottom": "20px",
                    "marginTop": "10vh"
                  }
                }
              },
              { // Sub Heading
                "fieldType": "paragraph",
                "fieldId": "vb309g",
                "properties": {
                  "text": "Upload a picture of your proof of purchase now.",
                  "classes": ["subHeading"],
                  "grid": {
                    "alignItems": "center",
                    "justifyContent": "center",
                    "columns": "12",
                    "marginBottom": "50px"
                  }
                }
              },
              { // Sub Text
                "fieldType": "paragraph",
                "fieldId": "94xqe4",
                "properties": {
                  "text": `Upload your receipt photo using drag and drop. Only JPEG, PDF and PNG are supported. Maximum file size: 16MB.`,
                  "grid": {
                    "alignItems": "center",
                    "justifyContent": "center",
                    "columns": "12"
                  },
                  "classes": ["subText"]
                }
              }
            ]
          },
          { // Receipt Info and Upload
            "sectionId": "dyx8uv",
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "fields": [
              { // Query string
                "fieldType": "query-string-to-state",
                "fieldId": "uwxo2o1",
                properties: {
                  variables: [
                    {
                      query: "referenceNumber",
                      state: "formData"
                    }
                  ]
                }
              },
              { // 72 Hours check
                "fieldType": "checkReceiptToken",
                "fieldID": "dksnfsdkjf",
                properties: {
                  grid: { columns: 12 }
                }
              },
              { // empty bucket
                "fieldType": "empty-bucket",
                "fieldId": "h453eadaf",
                "properties": {
                  "grid": {
                    "columns": "10",
                    "marginTop": "50px"
                  },
                  "styles": {
                    "justify-content": "center"
                  },
                  "fields": [
                    { // Receipt Upload
                      "fieldType": "receipt-processor",
                      "fieldId": "klvakj",
                      "properties": {
                        texts: {
                          choose: 'Choose a file',
                          receiptUpload1: 'Upload your receipt photo',
                          receiptUpload2: 'Drag & Drop or click here',
                          wrongFormat: 'This file format is not supported. Only .jpeg, .png, .pdf and .tiff files are accepted.',
                          fileSizeLimit: 'The file is too big. Only files up to 16 MB are supported.'
                        },
                        "colorSchema": "var(--color4)",
                        "grid": {
                          "columns": "6",
                          "alignItems": "center",
                          "justifyContent": "center"
                        },
                        "addClass": "col-sm-9 col-md-6",
                        "successAction": {
                          "fn": "goToPage",
                          "params": "thank-you"
                        },
                        "reUpload": true,
                        "tokenName": "token",
                        "phrases": [
                          "Your receipt will now be uploaded and processed.",
                          "The receipt is processed automatically. This can take a minute. Please be patient.",
                          "If you get an error message, please take a better version of the receipt and upload it again."
                        ],
                        "cornerDetectionPhrases": [
                          "Please drag your receipt into the gray rectangle.",
                          "You can erase private information with the razor tool."
                        ],
                        "eraseColor": "#ffffff",
                        "eraseSize": 12,
                        "cropColor": "#3A96F3",
                        "cropBackground": "rgba(0,0,0,0.6)",
                        "cropTitle": "Crop",
                        "eraseTitle": "Rub out",
                        "dragTitle": "Drag",
                        "zoomInTitle": "Zoom in",
                        "zoomOutTitle": "Zoom out",
                        "selectImageTitle": "Select an Image",
                        "selectAnotherTitle": "Select Another",
                        "controlsBackground": "#4193d3",
                        "backgroundColorBtn": "var(--brand-color-2)"
                      }
                    },
                    { // Receipt Info
                      "fieldType": "empty-bucket",
                      "fieldId": "vdf932fd",
                      "properties": {
                        "grid": {
                          "columns": "6"
                        },
                        "className": "col-sm-9 col-md-6",
                        "fields": [
                          {
                            "fieldType": "receipt-information",
                            "fieldId": "5mq1p6",
                            "properties": {
                              "grid": {
                                "alignItems": "center",
                                "justifyContent": "center",
                                "columns": "12"
                              },
                              shouldDisplayFull: true,
                              "descriptionText": `Please photograph your proof of purchase!`,
                              "descriptionSubText": `Make sure that the following information is clearly visible:`,
                              "hideExamples": true,
                              "steps": [
                                { // Retailer
                                  "text": "Retailer",
                                  "label": "A"
                                },
                                {
                                  "text": "Promotional product and purchase price",
                                  "label": "B"
                                },
                                {
                                  "text": "Total of the proof of purchase",
                                  "label": "C"
                                },
                                {
                                  "text": "Date and time of purchase",
                                  "label": "D"
                                },
                                {
                                  "text": "Proof of purchase ID",
                                  "label": "E"
                                }
                              ]
                            }
                          }
                        ]
                      }
                    },
                    { // Receipt Examples
                      "fieldType": "empty-bucket",
                      "properties": {
                        "grid": {
                          "columns": 12,
                          "justifyContent": "center",
                          "margin": "0px auto"
                        },
                        "classes": "receiptUploader",
                        "fields": [
                          {
                            "fieldType": "receipt-examples",
                            "fieldId": "5mq1p6",
                            "properties": {
                              "grid": {
                                "alignItems": "center",
                                "justifyContent": "center",
                                "columns": "8"
                              }
                            }
                          }
                        ]
                      }
                    }
                  ]
                }
              }
            ]
          },
          { // Buttons
            "sectionId": "r0924fw",
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            container: true,
            "fields": [
              { // Next
                "fieldType": "button-component",
                "fieldId": "cwer23452q",
                "properties": {
                  "grid": {
                    "columns": 3,
                    "alignItems": "center",
                    "justifyContent": "center",
                    "marginBottom": "50px"
                  },
                  "text": "Send",
                  "addClass": "btn-next",
                  "shouldCheckCrop": true,
                  "requires": ["klvakj"],
                  "action": {
                    "fn": "sendReceipt",
                    "params": ""
                  }
                }
              }
            ]
          }
        ]
      },
      { // ::PAGE Product Re Uploader Back
        "pageName": "product-re-upload-be",
        "isPublic": true,
        "pageId": 10312,
        "sections" : [
          { // Query and Heading
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "sectionId": "vgw364bh",
            "fields": [
              { // Query
                "fieldType": "query-string-to-state",
                "fieldId": "uwxo2o1",
                properties: {
                  variables: [
                    {
                      query: "referenceNumber",
                      state: "formData"
                    }
                  ]
                }
              },
              { // Heading
                "fieldType": "paragraph",
                "fieldId": "uwxo2o",
                "properties": {
                  "text": "Re-Upload product photo",
                  "classes": ["heading"],
                  "grid": {
                    "alignItems": "center",
                    "justifyContent": "center",
                    "columns": "12",
                    "marginBottom": "20px",
                    "marginTop": "10vh"
                  }
                }
              },
              { // Sub Heading
                "fieldType": "paragraph",
                "fieldId": "vb309g",
                "properties": {
                  "text": "Please upload a photo of the product page on which the EAN barcode is clearly visible.",
                  "classes": ["subHeading"],
                  "grid": {
                    "alignItems": "center",
                    "justifyContent": "center",
                    "columns": "12",
                    "marginBottom": "50px"
                  }
                }
              },
              { // Sub Text
                "fieldType": "paragraph",
                "fieldId": "94xqe4",
                "properties": {
                  "text": `Upload your receipt photo using drag and drop. Only JPEG and PNG are supported. Maximum file size: 16MB.`,
                  "grid": {
                    "alignItems": "center",
                    "justifyContent": "center",
                    "columns": "12"
                  },
                  "classes": ["subText"]
                }
              }
            ]
          },
          { // Product Re Uploader
            "sectionId": "dyx8uv",
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center",
              "marginBottom": "50px"
            },
            "fields": [
              { // 72 Hours check
                "fieldType": "checkReceiptToken",
                "fieldID": "dksnfsdkjf",
                properties: {
                  grid: { columns: 12 }
                }
              },
              {
                "fieldType": "empty-bucket",
                "fieldId": "h453eadaf",
                "properties": {
                  "grid": {
                    "columns": "12"
                  },
                  "styles": {
                    "justifyContent": "center !important",
                    "maxWidth": "871px !important",
                    padding: 0
                  },
                  "className": "col-sm-9 col-xl-6",
                  "fields": [
                    {
                      "fieldType": "product-upload",
                      "fieldId": "cakl305",
                      "properties": {
                        texts: {
                          choose: 'Choose a file',
                          receiptUpload1: 'Upload product photo',
                          receiptUpload2: 'Drag & Drop or click here',
                          wrongFormat: 'This file format is not supported. Only .jpeg, .png, .pdf and .tiff files are accepted.',
                          fileSizeLimit: 'The file is too big. Only files up to 16 MB are supported.'
                        },
                        "colorSchema": "var(--brand-color-2)",
                        "grid": {
                          "columns": "12",
                          "alignItems": "center",
                          "justifyContent": "center"
                        },
                        "reupload": {
                          "status": true
                        },
                        "reUpload": true,
                        "tokenName": "token",
                        "apiUrl": "https://template-v2.justsnap.eu/api/uploadProductPhoto",
                        "successAction": {
                          "fn": "goToPage",
                          "params": "thank-you"
                        }
                      }
                    }
                  ]
                }
              }
            ]
          },
          { // Button
            "sectionId": "r0924fw",
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center",
              "maxWidth": "1440px"
            },
            container: true,
            "fields": [
              {
                "fieldType": "button-component",
                "fieldId": "cwer23452q",
                "properties": {
                  "grid": {
                    "columns": "3",
                    "alignItems": "center",
                    "justifyContent": "center",
                    "marginBottom": "50px"
                  },
                  "text": "Send",
                  "shouldCheckCrop": true,
                  "requires": ["cakl305"],
                  "addClass": "btn-next",
                  "action": {
                    "fn": "sendProductPhotos",
                    "params": "cakl305"
                  }
                }
              }
            ]
          }
        ]
      },
      { // ::PAGE Product Re Upload Front
        "pageName": "product-re-upload-fe",
        "isPublic": true,
        "pageId": 1031214,
        "sections": [
          { // Query and Heading
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "sectionId": "vgw364bh",
            "fields": [
              { // Query
                "fieldType": "query-string-to-state",
                "fieldId": "uwxo2o1",
                properties: {
                  variables: [
                    {
                      query: "referenceNumber",
                      state: "formData"
                    },
                    {
                      query: "token",
                      state: "receiptToken"
                    }
                  ]
                }
              },
              { // Heading
                "fieldType": "paragraph",
                "fieldId": "uwxo2o",
                "properties": {
                  "text": "Re-Upload product photo",
                  "classes": ["heading"],
                  "grid": {
                    "alignItems": "center",
                    "justifyContent": "center",
                    "columns": "12",
                    "marginBottom": "20px",
                    "marginTop": "10vh"
                  }
                }
              },
              { // Sub Heading
                "fieldType": "paragraph",
                "fieldId": "vb309g",
                "properties": {
                  "text": "Please upload a photo of the front of your Oral-B products with the yellow banner.",
                  "classes": ["subHeading"],
                  "grid": {
                    "alignItems": "center",
                    "justifyContent": "center",
                    "columns": "12",
                    "marginBottom": "50px"
                  }
                }
              },
              { // Sub Text
                "fieldType": "paragraph",
                "fieldId": "94xqe4",
                "properties": {
                  "text": `Upload your receipt photo using drag and drop. Only JPEG and PNG are supported. Maximum file size: 16MB.`,
                  "grid": {
                    "alignItems": "center",
                    "justifyContent": "center",
                    "columns": "12"
                  },
                  "classes": ["subText"]
                }
              }
            ]
          },
          { // Product Re Uploader
            "sectionId": "dyx8uv",
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center",
              "marginBottom": "50px"
            },
            "fields": [
              { // 72 Hours check
                "fieldType": "checkReceiptToken",
                "fieldID": "dksnfsdkjf",
                properties: {
                  grid: { columns: 12 }
                }
              },
              { // Product uploader
                "fieldType": "empty-bucket",
                "fieldId": "h453eadaf",
                "properties": {
                  "grid": {
                    "columns": "12"
                  },
                  "styles": {
                    "justifyContent": "center !important",
                    "maxWidth": "871px !important",
                    padding: 0
                  },
                  "className": "col-sm-9 col-xl-6",
                  "fields": [
                    { // Product uploader
                      "fieldType": "product-upload",
                      "fieldId": "cakl305",
                      "properties": {
                        texts: {
                          choose: 'Choose a file',
                          receiptUpload1: 'Upload product photo',
                          receiptUpload2: 'Drag & Drop or click here',
                          wrongFormat: 'This file format is not supported. Only .jpeg, .png, .pdf and .tiff files are accepted.',
                          fileSizeLimit: 'The file is too big. Only files up to 16 MB are supported.'
                        },
                        "colorSchema": "var(--brand-color-2)",
                        "grid": {
                          "columns": "12",
                          "alignItems": "center",
                          "justifyContent": "center"
                        },
                        "reupload": {
                          "status": true
                        },
                        "reUpload": true,
                        "tokenName": "token",
                        "apiUrl": "https://template-v2.justsnap.eu/api/uploadProductPhoto",
                        "successAction": {
                          "fn": "goToPage",
                          "params": "thank-you"
                        }
                      }
                    }
                  ]
                }
              }
            ]
          },
          { // Button
            "sectionId": "r0924fw",
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center",
              "maxWidth": "1440px"
            },
            container: true,
            "fields": [
              { //
                "fieldType": "button-component",
                "fieldId": "cwer23452q",
                "properties": {
                  "grid": {
                    "columns": "3",
                    "alignItems": "center",
                    "justifyContent": "center",
                    "marginBottom": "50px"
                  },
                  "text": "Send",
                  "shouldCheckCrop": true,
                  "requires": ["cakl305"],
                  "addClass": "btn-next",
                  "action": {
                    "fn": "sendProductPhotos",
                    "params": "cakl305"
                  }
                }
              }
            ]
          }
        ]
      },
      { // ::PAGE Product Re Upload Front and Back
        "pageName": "product-re-upload-fe-be",
        "isPublic": true,
        "pageId": 103,
        "sections": [
          { // Query and Heading
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "sectionId": "vgw364bh",
            "fields": [
              { // Query
                "fieldType": "query-string-to-state",
                "fieldId": "uwxo2o1",
                properties: {
                  variables: [
                    {
                      query: "referenceNumber",
                      state: "formData"
                    },
                    {
                      query: "token",
                      state: "receiptToken"
                    }
                  ]
                }
              },
              { // Heading
                "fieldType": "paragraph",
                "fieldId": "uwxo2o",
                "properties": {
                  "text": "Re-Upload product photo",
                  "classes": ["heading"],
                  "grid": {
                    "alignItems": "center",
                    "justifyContent": "center",
                    "columns": "12",
                    "marginBottom": "20px",
                    "marginTop": "10vh"
                  }
                }
              },
              { // Sub Heading
                "fieldType": "paragraph",
                "fieldId": "vb309g",
                "properties": {
                  "text": "Please upload a photo of the front of your Oral-B products with the yellow banner.",
                  "classes": ["subHeading"],
                  "grid": {
                    "alignItems": "center",
                    "justifyContent": "center",
                    "columns": "12",
                    "marginBottom": "50px"
                  }
                }
              },
              { // Sub Text
                "fieldType": "paragraph",
                "fieldId": "94xqe4",
                "properties": {
                  "text": `Upload your receipt photo using drag and drop. Only JPEG and PNG are supported. Maximum file size: 16MB.`,
                  "grid": {
                    "alignItems": "center",
                    "justifyContent": "center",
                    "columns": "12"
                  },
                  "classes": ["subText"]
                }
              }
            ]
          },
          { // Product Re Uploader
            "sectionId": "dyx8uv",
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center",
              "marginBottom": "50px"
            },
            "fields": [
              { // 72 Hours check
                "fieldType": "checkReceiptToken",
                "fieldID": "dksnfsdkjf",
                properties: {
                  grid: { columns: 12 }
                }
              },
              { // Product uploader
                "fieldType": "empty-bucket",
                "fieldId": "h453eadaf",
                "properties": {
                  "grid": {
                    "columns": "12"
                  },
                  "styles": {
                    "justifyContent": "center !important",
                    "maxWidth": "871px !important",
                    padding: 0
                  },
                  "className": "col-sm-9 col-xl-6",
                  "fields": [
                    { // Product uploader
                      "fieldType": "product-upload",
                      "fieldId": "cakl305",
                      "properties": {
                        texts: {
                          choose: 'Choose a file',
                          receiptUpload1: 'Upload product photo',
                          receiptUpload2: 'Drag & Drop or click here',
                          wrongFormat: 'This file format is not supported. Only .jpeg, .png, .pdf and .tiff files are accepted.',
                          fileSizeLimit: 'The file is too big. Only files up to 16 MB are supported.'
                        },
                        "colorSchema": "var(--brand-color-2)",
                        "grid": {
                          "columns": "12",
                          "alignItems": "center",
                          "justifyContent": "center"
                        },
                        "reupload": {
                          "status": true
                        },
                        "reUpload": true,
                        "tokenName": "token",
                        "apiUrl": "https://template-v2.justsnap.eu/api/uploadProductPhoto",
                        "successAction": {
                          "fn": "goToPage",
                          "params": "product-re-upload-be"
                        }
                      }
                    }
                  ]
                }
              }
            ]
          },
          { // Button
            "sectionId": "r0924fw",
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center",
              "maxWidth": "1440px"
            },
            container: true,
            "fields": [
              {
                "fieldType": "button-component",
                "fieldId": "cwer23452q",
                "properties": {
                  "grid": {
                    "columns": "3",
                    "alignItems": "center",
                    "justifyContent": "center",
                    "marginBottom": "50px"
                  },
                  "text": "Send",
                  "shouldCheckCrop": true,
                  "addClass": "btn-next",
                  "requires": ["cakl305"],
                  "action": {
                    "fn": "sendProductPhotos",
                    "params": "cakl305"
                  }
                }
              }
            ]
          }
        ]
      },
      { // ::PAGE Iban reuploader
        "pageName": "re-iban",
        "isPublic": true,
        "pageId": 104,
        "requires": [
          1
        ],
        "sections": [
          { // HEADING AND SUBHEADING
            "grid": {
              "alignItems": "center",
              "justifyContent": "center",
              "flex-direction": "column",
              "columns": 12
            },
            "fields": [
              { // IBAN reupload
                "fieldType": "iban-reupload",
                "fieldId": "ij3411"
              },
              { // Heading
                "fieldType": "paragraph",
                "fieldId": "uwxo2o",
                "properties": {
                  "text": "Specify bank details",
                  "classes": ["heading"],
                  "grid": {
                    "alignItems": "center",
                    "justifyContent": "center",
                    "columns": "12",
                    "marginBottom": "20px",
                    "marginTop": "10vh"
                  }
                }
              },
              { // Sub Heading
                "fieldType": "paragraph",
                "fieldId": "vb309g",
                "properties": {
                  "text": "Please enter the first and last name of the account holder exactly as they were given at the bank.",
                  "classes": ["subHeading"],
                  "grid": {
                    "alignItems": "center",
                    "justifyContent": "center",
                    "columns": "12",
                    "marginBottom": "50px"
                  }
                }
              },
              { // Sub Text
                "fieldType": "paragraph",
                "fieldId": "94xqe4",
                "properties": {
                  "text": `Avoid changing the umlauts: Müller or Mueller. Avoid adding or leaving out hyphens: Marie Luise or Marie-Luise. Only enter the middle name if the account is also managed with it.`,
                  "grid": {
                    "alignItems": "center",
                    "justifyContent": "center",
                    "columns": "12"
                  },
                  "classes": ["subText"]
                }
              }
            ]
          },
          { // FORMS
            "sectionId": "mfh0h1",
            "grid": {
              "alignItems": "center",
              "justifyContent": "center",
              "columns": 12,
              "marginBottom": "50px"
            },
            "fields": [
              { // Forms
                "fieldType": "form-component",
                "fieldId": "bank1Nf0",
                "properties": {
                  "successAction": {
                    "fn": "goToPage",
                    "params": "iban-thank-you"
                  },
                  "apiUrl": "https://template-v2.justsnap.eu/api/updateIBAN",
                  "grid": {
                    "alignItems": "center",
                    "justifyContent": "center",
                    "columns": "12"
                  },
                  "styles": {
                    "margin": "0",
                    "alignItems": "center",
                    "flexDirection": "column"
                  },
                  "fields": [
                    {
                      "fieldType": "empty-bucket",
                      "fieldId": "f934if",
                      "properties": {
                        "grid": {
                          "columns": "6",
                          "justifyContent": "center",
                          "alignItems": "center"
                        },
                        "classes": "form-top-wrapper",
                        "fields": [
                          {
                            "fieldType": "empty-bucket",
                            "fieldId": "emep123",
                            "properties": {
                              "grid": {
                                "columns": 12,
                                "justifyContent": "center",
                                "alignItems": "center"
                              },
                              "classes": "form-wrapper",
                              "fields": [
                                { // IBAN
                                  "fieldId": "h9arlr",
                                  "fieldType": "text-input",
                                  "properties": {
                                    "name": "iban",
                                    "id": "iban",
                                    "validation": "required|iban",
                                    "label": "IBAN",
                                    "placeholder": "Enter your IBAN",
                                    "isUpperCase": true,
                                    "text": "",
                                    labelOnTop: true,
                                    "toolTip": {
                                      "title": "What is IBAN and where do I find it?",
                                      "text": `IBAN stands for International Bank Account Number. It's an internationally-agreed code made up of up to 34 letters and numbers that helps banks to process transfers around the world. You can usually find your IBAN number on the top right- hand side of your bank statement or in your online banking.If you can't locate your IBAN, you should be able to generate it online via your bank's internet banking service or by using an IBAN calculator tool.`
                                    },
                                    "grid": {
                                      "columns": "12"
                                    },
                                    "styles": {
                                      "font-family": 'Montserrat',
                                      "margin-bottom": "20px"
                                    }
                                  }
                                },
                                { // BIC
                                  "fieldId": "v1nf34",
                                  "fieldType": "text-input",
                                  "properties": {
                                    "name": "bic",
                                    "id": "bic",
                                    "label": "BIC",
                                    "validation": "required|bic",
                                    "placeholder": "Enter your BIC",
                                    "isUpperCase": true,
                                    labelOnTop: true,
                                    "toolTip": {
                                      "title": "What is BIC and where do I find it?",
                                      "text": "BIC stands for Bank Identifier Code. To send or receive money, any financial institution must know where to send the money and BIC is exactly what shows it. You can usually find your bank's BIC in your bank account statements.If you're using online banking, log into your digital bank account to easily view your bank statement or contact your bank so that they provide you your BIC."
                                    },
                                    "grid": {
                                      "columns": "12"
                                    },
                                    styles: {
                                      "margin-bottom": "20px"
                                    }
                                  }
                                },
                                { // Firstname
                                  "fieldId": "tp6zfb",
                                  "fieldType": "text-input",
                                  "properties": {
                                    "name": "firstname",
                                    "id": "firstname",
                                    "label": "Account holder first name",
                                    "placeholder": "Enter your first name",
                                    "validation": "required|namesWithHyphensAndSpaces",
                                    labelOnTop: true,
                                    "grid": {
                                      "columns": "12"
                                    },
                                    styles: {
                                      "margin-bottom": "20px"
                                    }
                                  }
                                },
                                { // Last name
                                  "fieldId": "p55fao",
                                  "fieldType": "text-input",
                                  "properties": {
                                    "name": "lastname",
                                    "id": "lastname",
                                    "label": "Account holder last name",
                                    "placeholder": "Enter your last name",
                                    "validation": "required|namesWithHyphensAndSpaces",
                                    labelOnTop: true,
                                    "grid": {
                                      "columns": "12"
                                    }
                                  }
                                }
                              ]
                            }
                          }
                        ]
                      }
                    }
                  ]
                }
              },
              { // Disclaimer
                "fieldType": "paragraph",
                "fieldId": "0bbo32",
                "properties": {
                  "text": "If the data does not exactly match the account details, in most cases the bank will charge back and make the process of an uncomplicated and quick refund more difficult.",
                  "grid": {
                    "alignItems": "center",
                    "justifyContent": "center",
                    "columns": "6",
                    "marginTop": "15px"
                  },
                  "styles": {
                    "font-size": "14px"
                  }
                }
              }
            ]
          },
          { // Buttons
            "sectionId": "r0924fw",
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            container: true,
            "fields": [
              { // Next
                "fieldType": "button-component",
                "fieldId": "cwer23452q",
                "properties": {
                  "grid": {
                    "columns": 3,
                    "alignItems": "center",
                    "justifyContent": "center",
                    "marginBottom": "50px"
                  },
                  "text": "Send",
                  "addClass": "btn-next",
                  "shouldCheckCrop": true,
                  "disabled": false,
                  "action": {
                    "fn": "sendForm",
                    "params": "bank1Nf0"
                  }
                }
              }
            ]
          }
        ]
      },
      { // Iban thank you page
        "pageName": "iban-thank-you",
        "pageId": 10431,
        isPublic: true,
        "sections": [
          { // Heading and subheading
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "fields": [
              { // Heading
                "fieldType": "paragraph",
                "fieldId": "uwxo2o",
                "properties": {
                  "text": "Thank you",
                  "classes": ["heading"],
                  "grid": {
                    "alignItems": "center",
                    "justifyContent": "center",
                    "columns": "12",
                    "marginBottom": "20px",
                    "marginTop": '10vh'
                  }
                }
              },
              { // Sub Heading
                "fieldType": "paragraph",
                "fieldId": "vb309g",
                "properties": {
                  "text": "Thank you for resubmitting your bank details.",
                  "classes": ["subHeading"],
                  "grid": {
                    "alignItems": "center",
                    "justifyContent": "center",
                    "columns": "12",
                    "marginBottom": "50px"
                  }
                }
              },
              { // Sub Text
                "fieldType": "paragraph",
                "fieldId": "94xqe4",
                "properties": {
                  "text": `So nothing should stand in the way of a successful transfer.`,
                  "grid": {
                    "alignItems": "center",
                    "justifyContent": "center",
                    "columns": "12",
                    "marginBottom": "50px"
                  },
                  "classes": ["subText"]
                }
              },
              { // Sub Text
                "fieldType": "paragraph",
                "fieldId": "94xqe4",
                "properties": {
                  "text": `If you have any questions related to your bank details, please contact <a href='mailto:support@oral-b-moneyback.com'><b>support@oral-b-moneyback.com</b></a>.`,
                  "grid": {
                    "alignItems": "center",
                    "justifyContent": "center",
                    "columns": "12"
                  },
                  "classes": ["subHeading"]
                }
              },
              { // Sub Text
                "fieldType": "paragraph",
                "fieldId": "94xqe4",
                "properties": {
                  "text": `For other concerns, you can contact our support service at <a href='mailto:contact@oral-b-moneyback.com'><b>contact@oral-b-moneyback.com</b></a>.`,
                  "grid": {
                    "alignItems": "center",
                    "justifyContent": "center",
                    "columns": "12",
                    "marginBottom": "20vh"
                  },
                  "classes": ["subHeading"]
                }
              }
            ]
          },
          { // Button
            "sectionId": "1265vb4k",
            "grid": {
              "columns": 10,
              "alignItems": "center",
              "justifyContent": "flex-start"
            },
            "fields": [
              { // Button
                "fieldType": "button-component",
                "fieldId": "7bltcc",
                "properties": {
                  "grid": {
                    "columns": 3,
                    "alignItems": "center",
                    "justifyContent": "center",
                    "paddingTop": "10px",
                    "paddingBottom": "10px",
                    "marginBottom": "50px"
                  },
                  "text": "Back to the Oral-B website",
                  'addClass': 'btn-back',
                  "disabled": false,
                  "action": {
                    "anchor": true,
                    "link": "oralb_website"
                  }
                }
              }
            ]
          }
        ]
      }
    ],
    "header": {
      "fieldType": "navbar",
      "fieldId": "cbx34t",
      "properties": {
        "backgroundColor": "#fff",
        "title": "",
        "color": "#0051AD",
        "grid": {
          "columns": 12
        },
        "logo": {
          "imageSource": "/assets/banner/logo.png",
          "width": 86,
          "alternateText": "Oral-B Logo"
        },
        "favicon": {
          "imageSource": "https://azcdn.pioneer.pgsitecore.com/en-gb/-/media/Downy_UK/Images/Common/favicon-32x32.jpg?v=1-201708041111"
        },
        "languages": [
          { text: "Danmark", code: "dk", flag: "/assets/images/flags/denmark.svg" },
          { text: "Norge", code: "no", flag: "/assets/images/flags/norway.svg" },
          { text: "Suomi", code: "fi", flag: "/assets/images/flags/finland.svg" },
          { text: "Sverige", code: "se", flag: "/assets/images/flags/sweden.svg" }
        ],
        "fields": [
          {
            "fieldId": "ikz8vc",
            "fieldType": "anchor",
            "properties": {
              "text": 'Terms and Conditions',
              "url": "/terms",
              "target": "_blank",
              "cssClass": "nav-link headingLink"
            }
          },
          {
            "fieldId": "slnmdk",
            "fieldType": "anchor",
            "properties": {
              "text": 'FAQ',
              "url": "/faq",
              "target": "_blank",
              "cssClass": "nav-link headingLink"
            }
          }
        ],
        "showLine": true,
        "meta": [
          { "name": "title", "content": "Oral-B Zahncreme Gratis Testen" },
          {
            "name": "description",
            "content": `Oral-B Testen Aktion - Großartige Sonderaktionen, Gratis Testen, Angebote. Alle Aktionen auf einen Blick! `
          },
          {
            "name": "keywords",
            "content": `Oral-B Zahnfleisch und -schmelz Original, ‎Oral-B PROFESSIONAL Zahnfleisch und -schmelz Original , Oral-B Professional Sensitivität und Zahnfleischbalsam Sanfte Reinigung , ‎Oral-B Kinderzahncreme Junior ab 6 J 75ml Star Wars`
          }
        ]
      }
    },
    "footer": {
      "fieldType": "footer-component",
      "fieldId": "4tfbzz"
    },
    "errors": {
      "en": {
        default: 'Oops. An error has occurred. Please try again later.',
        iban: '',
        ibanUsed: 'This IBAN has already been used together with another email address.',
        emailUsed: 'An account is already registered with this email. Please log in with this email on the login page.',
        receipt: 'An error has occurred. Please update the website.',
        product: '',
        survey: 'Survey error',
        server: 'There is currently a problem with our website. Please try again in a few minutes.',
        technical: 'There is a technical error. Please wait a moment and try again.'
      },
      "dk": {
        default: 'Ups. Der er opstået en fejl. Prøv venligst igen senere.',
        iban: '',
        ibanUsed: 'Dette IBAN er allerede blevet brugt sammen med en anden e-mailadresse.',
        emailUsed: 'Der er allerede registreret en-konto med denne e-mail. Du bedes logge ind med denne e-mail på login-siden.',
        receipt: 'Der er opstået en fejl. Opdater venligst hjemmesiden.',
        product: '',
        survey: '',
        server: 'Der er i øjeblikket et problem med vores websted. Prøv venligst igen om et par minutter.',
        technical: 'Der er sket en teknisk fejl. Vent venligst et øjeblik og prøv igen.'
      },
      "fi": {
        default: 'Hups. On tapahtunut virhe. Yritä myöhemmin uudelleen.',
        iban: '',
        ibanUsed: 'Tätä IBAN-tilinumeroa on jo käytetty yhdessä toisen sähköpostiosoitteen kanssa.',
        emailUsed: 'Tällä sähköpostilla on jo rekisteröity tili. Ole hyvä ja kirjaudu sisään tällä sähköpostilla kirjautumissivulla.',
        receipt: 'On tapahtunut virhe. Ole hyvä ja päivitä verkkosivusto.',
        product: '',
        survey: '',
        server: 'Verkkosivustossamme on tällä hetkellä ongelma. Yritä uudelleen muutaman minuutin kuluttua.',
        technical: 'On tapahtunut tekninen virhe. Odota hetki ja yritä uudelleen.'
      },
      "no": {
        default: 'Oops. Det har oppstått en feil. Prøv på nytt senere.',
        iban: '',
        ibanUsed: 'Denne IBAN-en er allerede brukt sammen med en annen e-postadresse.',
        emailUsed: 'En-konto er allerede registrert med denne e-posten. Logg inn med denne e-posten på innloggingssiden.',
        receipt: 'Det har oppstått en feil. Oppdater webområdet.',
        product: '',
        survey: '',
        server: 'Det er for øyeblikket et problem med nettstedet vårt. Prøv på nytt om noen minutter.',
        technical: 'Det er en teknisk feil. Vent litt, og prøv på nytt.'
      },
      "se": {
        default: 'Oops. Ett fel har inträffat. Försök igen senare.',
        iban: '',
        ibanUsed: 'Detta IBAN har redan använts tillsammans med en annan e-postadress.',
        emailUsed: 'Ett ""-konto är redan registrerat med denna e-postadress. Vänligen logga in med denna e-postadress på inloggningssidan.',
        receipt: 'Ett fel har uppstått. Vänligen uppdatera webbplatsen.',
        product: '',
        survey: '',
        server: 'Det finns för närvarande ett problem med vår webbplats. Försök igen om några minuter.',
        technical: 'Det har uppstått ett tekniskt fel. Vänligen vänta ett ögonblick och försök igen.'
      }
    },
    "campaignId": "oralb-moneyback-se",
    "url": "http://www.oralb-moneyback.com/",
    "name": "oralb-moneyback"
  },
  pageBuilder: {
    selectedField: {
      sectionId: '',
      fieldId: generateUID()
    }
  },
  componentStatus: {},
  modal: {
    type: 'error',
    message: 'Ein Fehler ist aufgetreten',
    isActive: false
  },
  customerToken: '',
  receiptToken: '',
  receiptImage: '',
  campaignId: 'oralb-moneyback-se',
  formData: new FormData(),
  campaignEndDate: '2026-08-31',
  scannerActive: false,
  file: {},
  countriesIBAN: [
    'NO',
    'FI',
    'DK',
    'SE'
  ],
  barcode: {
    code: '',
    format: ''
  },
  productCode: '',
  searchStatus: null,
  imgList: [],
  errorMessage: "Der Barcode ist ungültig. Bitte versuchen Sie erneut, den Barcode einzugeben oder zu scannen. Glauben Sie, dass es sich um einen Fehler handelt?",
  errorImageList: ["", ""],
  errorActivate: false,
  scannedProducts: [],
  types: ['ean_reader', 'code_128_reader', 'code_39_reader', 'ean_8_reader', 'upc_reader', 'upc_e_reader', 'i2of5_reader', '2of5_reader', 'code_93_reader', 'codabar_reader'],
  pageToBack: '',
  receiptBarcode: '',
  isReceiptImageChanged: false,
  convertedImagePointsData: {},
  firstTimeUploading: true,
  countryCode: '',
  tel: ''
}
